var _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-2",
    d: "M78.06,459.59c-95-47.86-95-125.47,0-173.33s248.92-47.87,343.88,0,95,125.47,0,173.33S173,507.46,78.06,459.59Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--Shadow--inject-2",
    points: "288.79 358.57 368.51 312.45 475 373.99 395.27 420.02 331.72 383.34 318.41 391.02 295.3 377.68 308.6 370 288.79 358.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-2",
    points: "33.92 438.67 16.5 428.59 192.38 327.04 209.79 337.13 33.92 438.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M363.41,424.41l-20.22-11.67a.67.67,0,0,1,0-1.26l4.95-2.86a2.44,2.44,0,0,1,2.17,0l20.22,11.68a.66.66,0,0,1,0,1.25L368.06,423l25.37,14.65c.6.35.35.47.07.63s-.49.31-1.08,0L367,423.57l-1.46.84A2.37,2.37,0,0,1,363.41,424.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M306.13,416.24l5.95-3.58a2.14,2.14,0,0,1,1.94,0l22.35,12.88a.59.59,0,0,1,0,1.12l-1,.55,32.13,18.3,0,0a1.44,1.44,0,0,1,1.15-.06,9.43,9.43,0,0,0,4.31.95,5.77,5.77,0,0,0,4.55-5.53,4.61,4.61,0,0,1,.42,5.08,9.54,9.54,0,0,1-4,4.33c-.3.19-.8.48-1.11.66l-4.13,2.42a2.84,2.84,0,0,1-1.2.33h-.81a2.84,2.84,0,0,0-1.21.33l-2,.93,1.29.74a.59.59,0,0,1,0,1.12l-2.29,1.33a2.14,2.14,0,0,1-1.94,0l-6.53-3.77a.59.59,0,0,1,0-1.12l2.29-1.32a2.16,2.16,0,0,1,1.95,0l1.14.66a7.56,7.56,0,0,0,.86-.4l1-.58a1.18,1.18,0,0,0,.54-.88l1.93-2.33-32.73-18.63-.87.51a2,2,0,0,1-1.84-.05l-22.2-12.82A.61.61,0,0,1,306.13,416.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M198.94,423.3c25.41,14.67,66.61,14.67,92,0s25.41-38.46,0-53.13-66.6-14.67-92,0S173.54,408.63,198.94,423.3Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.83,44.57,76.1,46V37.79c0-6.51-5.19-8.07-10.83-4.82h0c-5.64,3.26-10.21,11.17-10.21,17.68v1.2a5.43,5.43,0,0,0-4.73.73h0A16.22,16.22,0,0,0,43,65.3v.54l-5.2,3A10.68,10.68,0,0,0,33,77.22c0,3.08,2.16,4.33,4.83,2.79L79.83,55.74a10.7,10.7,0,0,0,4.83-8.38C84.66,44.27,82.5,43,79.83,44.57Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.33,39.93l-6.75,3.9c0-.3,0-.6,0-.89V41c0-3.49-2.44-4.9-5.46-3.16A10.71,10.71,0,0,0,115.92,41c-.5-4.38-3.93-6-8.11-3.6C103.3,40,99.64,46.3,99.64,51.51v2.93a7.74,7.74,0,0,0,.69,3.39l-5.61,3.24a6.69,6.69,0,0,0-3,5.25c0,1.93,1.35,2.71,3,1.75l36.61-21.14a6.7,6.7,0,0,0,3-5.25C134.37,39.75,133,39,131.33,39.93Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clipboard--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190,32.36l-159.48,92a6.59,6.59,0,0,0-3,5.17v297a6.54,6.54,0,0,0,3,5.15l.61.35a6.64,6.64,0,0,0,6,0l159.49-92.09a6.59,6.59,0,0,0,3-5.17V37.85a6.55,6.55,0,0,0-3-5.15l-.6-.35A6.66,6.66,0,0,0,190,32.36Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,32.36l-159.48,92a6.59,6.59,0,0,0-3,5.17v297a6.54,6.54,0,0,0,3,5.15l.61.35a6.64,6.64,0,0,0,6,0l159.49-92.09a6.59,6.59,0,0,0,3-5.17V37.85a6.55,6.55,0,0,0-3-5.15l-.6-.35A6.66,6.66,0,0,0,190,32.36Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6,334.92c0,2.63-1.84,4.3-4.12,5.61L38.27,431.29c-2.27,1.31-4.12.25-4.12-2.38V134.56h0a8.21,8.21,0,0,1,4.1-7.11l157.23-90.8A2.74,2.74,0,0,1,199.6,39h0Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6,334.92c0,2.63-1.84,4.3-4.12,5.61L38.27,431.29c-2.27,1.31-4.12.25-4.12-2.38V134.56h0a8.21,8.21,0,0,1,4.1-7.11l157.23-90.8A2.74,2.74,0,0,1,199.6,39h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6,37.86V39a2.75,2.75,0,0,0-4.13-2.38L38.25,127.45a8,8,0,0,0-3,3,.2.2,0,0,0,0,.09l-6.8-3.93a6.1,6.1,0,0,1,2.14-2.27L190,32.36a6.64,6.64,0,0,1,6,0l.61.35A6.55,6.55,0,0,1,199.6,37.86Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.6,37.86V39a2.75,2.75,0,0,0-4.13-2.38L38.25,127.45a8,8,0,0,0-3,3,.2.2,0,0,0,0,.09l-6.8-3.93a6.1,6.1,0,0,1,2.14-2.27L190,32.36a6.64,6.64,0,0,1,6,0l.61.35A6.55,6.55,0,0,1,199.6,37.86Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M195.71,322.85c0,2.7-1.89,4.42-4.24,5.77L42.88,414.4c-2.33,1.35-4.24.26-4.24-2.45V149.77h0a8.46,8.46,0,0,1,4.22-7.33L191.47,56.62a2.83,2.83,0,0,1,4.24,2.45V322.85Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Form--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paper--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.44,145.66l148-85.48a2.84,2.84,0,0,1,2.54,0l1.43.83a2.78,2.78,0,0,1,1.26,2.19V326.59a2.79,2.79,0,0,1-1.26,2.19l-148,85.47a2.78,2.78,0,0,1-2.54,0l-1.43-.82a2.82,2.82,0,0,1-1.27-2.2V147.85A2.79,2.79,0,0,1,42.44,145.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,414.39a2.23,2.23,0,0,1-.46.13l-.25,0a3.31,3.31,0,0,1-.77,0,2.32,2.32,0,0,1-.47-.13,2.44,2.44,0,0,1-.28-.14l-1.42-.81a2.79,2.79,0,0,1-1.27-2.2V147.86a2.44,2.44,0,0,1,.37-1.25l4,2.28a2.61,2.61,0,0,0-.37,1.25V413.52C45.14,414.22,45.55,414.56,46.1,414.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.45,61,193,60.18a2.84,2.84,0,0,0-2.54,0l-148,85.48a2.79,2.79,0,0,0-1.27,2.19v16l4,2.31L195.71,79.2v-16A2.78,2.78,0,0,0,194.45,61Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.45,61,193,60.18a2.84,2.84,0,0,0-2.54,0l-148,85.48a2.79,2.79,0,0,0-1.27,2.19v16l4,2.31L195.71,79.2v-16A2.78,2.78,0,0,0,194.45,61Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.67,62.82c-.16-.52-.64-.68-1.22-.35l-148,85.47a2.5,2.5,0,0,0-.9.95l-4-2.28a2.43,2.43,0,0,1,.9-1l148-85.47a2.76,2.76,0,0,1,2.53,0l1.43.82A2.83,2.83,0,0,1,195.67,62.82Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.67,62.82c-.16-.52-.64-.68-1.22-.35l-148,85.47a2.5,2.5,0,0,0-.9.95l-4-2.28a2.43,2.43,0,0,1,.9-1l148-85.47a2.76,2.76,0,0,1,2.53,0l1.43.82A2.83,2.83,0,0,1,195.67,62.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.18,147.86v16l4,2.29v-16a2.61,2.61,0,0,1,.37-1.25l-4-2.28A2.44,2.44,0,0,0,41.18,147.86Z",
    style: {
      fill: "#242424"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Forms--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.38 128.95 187.14 96.75 187.14 99.81 131.38 132 131.38 128.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.77 139.41 187.14 102.86 187.14 105.91 123.77 142.46 123.77 139.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.61 141.01 187.14 108.97 187.14 112.02 131.61 144.07 131.61 141.01",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.98 151.12 72.6 162.88 72.6 165.94 92.98 154.17 92.98 151.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.59 152.79 72.6 168.99 72.6 172.04 100.59 155.84 100.59 152.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.75 163.45 72.6 175.1 72.6 178.15 92.75 166.5 92.75 163.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.27 397.18 111.33 363.67 111.33 366.29 53.27 399.81 53.27 397.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.95 353.49 187 319.97 187 322.6 128.95 356.11 128.95 353.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.71 171.59 59.48 168.39 51.26 181.09 53.2 179.97 53.2 190.24 65.76 182.98 65.76 172.72 67.71 171.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.27 348.84 187.14 271.55 187.14 277.6 53.27 354.88 53.27 348.84",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.28,354.88v24.18l133.86-77.29V277.59ZM186.5,301.39,53.92,377.94V355.26L186.5,278.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.27,
    y: 328,
    width: 153.88,
    height: 0.64,
    transform: "translate(-148.17 104.23) rotate(-30.03)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.25,
    y: 340.54,
    width: 0.64,
    height: 11.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.06,
    y: 300.92,
    width: 0.64,
    height: 11.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.78,357.72a.47.47,0,0,1-.42-.24.48.48,0,0,1,.18-.65l87.51-50.52a.48.48,0,0,1,.48.82L57,357.66A.53.53,0,0,1,56.78,357.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.78,361.57a.47.47,0,0,1-.42-.24.48.48,0,0,1,.18-.65l87.51-50.52a.48.48,0,1,1,.48.82L57,361.51A.53.53,0,0,1,56.78,361.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3,342.91a.49.49,0,0,1-.41-.24.48.48,0,0,1,.18-.65l79.86-46.12a.49.49,0,0,1,.66.18.48.48,0,0,1-.18.65l-79.87,46.11A.4.4,0,0,1,103.3,342.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3,346.76a.49.49,0,0,1-.41-.24.48.48,0,0,1,.18-.65l79.86-46.11a.48.48,0,1,1,.48.82l-79.87,46.11A.4.4,0,0,1,103.3,346.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.77,303.37a.48.48,0,0,1-.24-.89l32.4-18.71a.49.49,0,0,1,.66.18.48.48,0,0,1-.18.65L151,303.31A.53.53,0,0,1,150.77,303.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.77,307.22a.44.44,0,0,1-.41-.24.47.47,0,0,1,.17-.65l32.4-18.71a.49.49,0,0,1,.66.18.48.48,0,0,1-.18.65L151,307.16A.53.53,0,0,1,150.77,307.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.93,369.68a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.65l38.55-22.26a.48.48,0,0,1,.48.83L57.17,369.61A.44.44,0,0,1,56.93,369.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.93,373.53a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.65l38.55-22.26a.48.48,0,0,1,.48.83L57.17,373.47A.53.53,0,0,1,56.93,373.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.27 218.67 187.14 141.38 187.14 147.43 53.27 224.71 53.27 218.67",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.28,224.71v24.18L187.14,171.6V147.43ZM186.5,171.23,53.92,247.77V225.09L186.5,148.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.27,
    y: 197.83,
    width: 153.88,
    height: 0.64,
    transform: "translate(-82.98 86.66) rotate(-30)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.9,
    y: 198.15,
    width: 0.64,
    height: 11.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.93,227.64a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.65l126.25-72.89a.48.48,0,0,1,.65.17.49.49,0,0,1-.18.66L57.17,227.57A.42.42,0,0,1,56.93,227.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.93,231.49a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.65l126.25-72.89a.48.48,0,1,1,.47.83L57.17,231.42A.42.42,0,0,1,56.93,231.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.93,239.11a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.65l59.94-34.64a.49.49,0,0,1,.66.18.48.48,0,0,1-.18.65L57.17,239A.42.42,0,0,1,56.93,239.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.93,243a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.65l60-34.64a.48.48,0,1,1,.47.83L57.17,242.9A.5.5,0,0,1,56.93,243Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.23,200.83a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.65l59.94-34.64a.49.49,0,0,1,.66.18.48.48,0,0,1-.18.65l-59.94,34.64A.5.5,0,0,1,123.23,200.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.23,204.68a.47.47,0,0,1-.41-.24.48.48,0,0,1,.17-.65l60-34.64a.48.48,0,1,1,.47.83l-59.94,34.64A.5.5,0,0,1,123.23,204.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.27 253.93 187.14 176.64 187.14 182.69 53.27 259.97 53.27 253.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.28,260v24.18l133.86-77.29V182.69ZM186.5,206.49,53.92,283V260.35L186.5,183.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.27,
    y: 233.09,
    width: 153.88,
    height: 0.64,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -100.67, 91.47)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.25,
    y: 245.63,
    width: 0.64,
    height: 11.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.06,
    y: 206.01,
    width: 0.64,
    height: 11.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.78,263a.48.48,0,0,1-.42-.23.49.49,0,0,1,.18-.66l87.51-50.52a.48.48,0,0,1,.48.83L57,262.93A.53.53,0,0,1,56.78,263Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.78,266.85a.49.49,0,0,1-.42-.24.48.48,0,0,1,.18-.65l87.51-50.53a.48.48,0,0,1,.65.17.48.48,0,0,1-.17.66L57,266.78A.44.44,0,0,1,56.78,266.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3,247.92a.47.47,0,0,1-.41-.24.48.48,0,0,1,.18-.65l79.86-46.11a.48.48,0,0,1,.66.17.48.48,0,0,1-.18.65l-79.87,46.12A.48.48,0,0,1,103.3,247.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3,251.77a.47.47,0,0,1-.41-.24.48.48,0,0,1,.18-.65l79.86-46.11a.49.49,0,0,1,.66.17.49.49,0,0,1-.18.66l-79.87,46.11A.48.48,0,0,1,103.3,251.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.76,204.69a.44.44,0,0,1-.41-.24.47.47,0,0,1,.17-.65l25.41-14.67a.48.48,0,1,1,.48.83L158,204.63A.53.53,0,0,1,157.76,204.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.76,208.55a.46.46,0,0,1-.41-.24.48.48,0,0,1,.17-.66L182.93,193a.49.49,0,0,1,.66.18.48.48,0,0,1-.18.65L158,208.48A.44.44,0,0,1,157.76,208.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.93,274.69a.47.47,0,0,1-.41-.24.48.48,0,0,1,.17-.65l38.55-22.25a.48.48,0,0,1,.65.17.47.47,0,0,1-.17.65L57.17,274.63A.5.5,0,0,1,56.93,274.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.93,278.55a.49.49,0,0,1-.41-.24.47.47,0,0,1,.17-.65L95.24,255.4a.48.48,0,0,1,.48.83L57.17,278.48A.51.51,0,0,1,56.93,278.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,210.89a.46.46,0,0,1-.29-.1L151,208.72a.48.48,0,0,1,.58-.76l2.74,2.07a.48.48,0,0,1-.29.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.25,212.47a.59.59,0,0,1-.22-.05.48.48,0,0,1-.2-.65l2.74-5.24a.48.48,0,0,1,.64-.2.47.47,0,0,1,.21.64l-2.75,5.24A.46.46,0,0,1,151.25,212.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.27 289.19 187.14 211.91 187.14 217.95 53.27 295.23 53.27 289.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.28,295.23v12.09L187.14,230V218ZM186.5,229.66,53.92,306.21v-10.6L186.5,219.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.77,
    y: 268.67,
    width: 0.64,
    height: 11.26,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.29,
    y: 248.68,
    width: 0.64,
    height: 11.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.27 307.32 187.14 230.03 187.14 236.08 53.27 313.36 53.27 307.32",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.28,313.36v12.09l133.86-77.29V236.08ZM186.5,247.79,53.92,324.34v-10.6L186.5,237.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.77,
    y: 286.8,
    width: 0.64,
    height: 11.26,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.29,
    y: 266.81,
    width: 0.64,
    height: 11.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.27 325.45 187.14 248.16 187.14 254.21 53.27 331.49 53.27 325.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.28,331.49v12.09l133.86-77.29V254.21Zm.64,11v-10.6L186.5,255.33v10.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.77,
    y: 304.93,
    width: 0.64,
    height: 11.26,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.29,
    y: 284.94,
    width: 0.64,
    height: 11.32,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,294.63a.49.49,0,0,1-.42-.24.48.48,0,0,1,.18-.65l33.48-19.33a.48.48,0,0,1,.48.82L63.35,294.56A.39.39,0,0,1,63.12,294.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,298.48a.49.49,0,0,1-.42-.24.48.48,0,0,1,.18-.65l33.48-19.33a.48.48,0,1,1,.48.82L63.35,298.42A.46.46,0,0,1,63.12,298.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,312.56a.48.48,0,0,1-.24-.9l33.48-19.33a.48.48,0,0,1,.65.18.46.46,0,0,1-.17.65L63.35,312.49A.48.48,0,0,1,63.12,312.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,316.41a.49.49,0,0,1-.42-.24.48.48,0,0,1,.18-.65l33.48-19.34a.48.48,0,0,1,.65.18.46.46,0,0,1-.17.65L63.35,316.34A.39.39,0,0,1,63.12,316.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,330.48a.47.47,0,0,1-.42-.24.48.48,0,0,1,.18-.65l33.48-19.33a.48.48,0,0,1,.48.83L63.35,330.42A.46.46,0,0,1,63.12,330.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.12,334.33a.48.48,0,0,1-.42-.23.49.49,0,0,1,.18-.66l33.48-19.33a.48.48,0,0,1,.65.18.47.47,0,0,1-.17.65L63.35,334.27A.46.46,0,0,1,63.12,334.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,248a.44.44,0,0,1-.41-.24.47.47,0,0,1,.17-.65l39.21-22.64a.49.49,0,0,1,.66.18.48.48,0,0,1-.18.65L144.2,247.89A.53.53,0,0,1,144,248Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,251.81a.48.48,0,0,1-.24-.89l39.21-22.65a.49.49,0,0,1,.66.18.48.48,0,0,1-.18.65L144.2,251.74A.44.44,0,0,1,144,251.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,265.88a.44.44,0,0,1-.41-.24.46.46,0,0,1,.17-.65l39.21-22.64a.48.48,0,1,1,.48.83L144.2,265.82A.53.53,0,0,1,144,265.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,269.73a.44.44,0,0,1-.41-.24.47.47,0,0,1,.17-.65l39.21-22.64a.49.49,0,0,1,.66.18.48.48,0,0,1-.18.65L144.2,269.67A.53.53,0,0,1,144,269.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,283.81a.48.48,0,0,1-.24-.89l39.21-22.64a.48.48,0,1,1,.48.82L144.2,283.74A.44.44,0,0,1,144,283.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,287.66a.48.48,0,0,1-.24-.89l39.21-22.64a.48.48,0,1,1,.48.83L144.2,287.6A.53.53,0,0,1,144,287.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,267.44a.49.49,0,0,1-.42-.24.48.48,0,0,1,.18-.65l21.18-12.23a.48.48,0,1,1,.47.83l-21.17,12.23A.53.53,0,0,1,110.21,267.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,271.29a.47.47,0,0,1-.42-.24.48.48,0,0,1,.18-.65l21.18-12.23a.48.48,0,1,1,.47.83l-21.17,12.23A.53.53,0,0,1,110.21,271.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,285.37a.49.49,0,0,1-.42-.24.48.48,0,0,1,.18-.65l21.18-12.23a.48.48,0,0,1,.65.17.49.49,0,0,1-.18.66L110.45,285.3A.44.44,0,0,1,110.21,285.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,289.22a.49.49,0,0,1-.42-.24.48.48,0,0,1,.18-.65l21.18-12.23a.48.48,0,1,1,.47.83l-21.17,12.22A.44.44,0,0,1,110.21,289.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,303.29a.48.48,0,0,1-.42-.23.49.49,0,0,1,.18-.66l21.18-12.22a.46.46,0,0,1,.65.17.48.48,0,0,1-.18.65l-21.17,12.23A.53.53,0,0,1,110.21,303.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.21,307.15a.49.49,0,0,1-.42-.24.48.48,0,0,1,.18-.65L131.15,294a.48.48,0,0,1,.65.17.49.49,0,0,1-.18.66l-21.17,12.22A.44.44,0,0,1,110.21,307.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.05,273.6a.51.51,0,0,1-.29-.1L103,271.43a.48.48,0,1,1,.57-.76l2.74,2.07a.48.48,0,0,1,.1.67A.5.5,0,0,1,106.05,273.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3,275.18a.59.59,0,0,1-.22-.05.49.49,0,0,1-.2-.65l2.74-5.24a.49.49,0,0,1,.65-.2.48.48,0,0,1,.2.64l-2.74,5.24A.47.47,0,0,1,103.3,275.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4,271.69a.46.46,0,0,1-.29-.1l-2.74-2.07a.48.48,0,1,1,.58-.76l2.74,2.07a.48.48,0,0,1,.09.67A.49.49,0,0,1,140.4,271.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.66,273.27a.42.42,0,0,1-.22,0,.48.48,0,0,1-.21-.65l2.75-5.24a.48.48,0,0,1,.64-.2.47.47,0,0,1,.2.65L138.08,273A.47.47,0,0,1,137.66,273.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.52,336.75a.52.52,0,0,1-.29-.09l-2.74-2.08a.48.48,0,0,1,.58-.76l2.74,2.08a.46.46,0,0,1,.09.66A.46.46,0,0,1,59.52,336.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.78,338.34a.43.43,0,0,1-.22-.06.47.47,0,0,1-.21-.64l2.75-5.24a.47.47,0,1,1,.84.44l-2.74,5.24A.49.49,0,0,1,56.78,338.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8,303.52a.55.55,0,0,1-.24-.07.46.46,0,0,1-.24-.41v-5.48a.46.46,0,0,1,.24-.41l4.11-2.37a.48.48,0,0,1,.72.41v5.48a.47.47,0,0,1-.24.41L56,303.45A.51.51,0,0,1,55.8,303.52Zm.48-5.68v4.37l3.15-1.82V296Zm3.63,2.83h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.62,294.41a.53.53,0,0,1-.24-.06.48.48,0,0,1-.24-.42v-5.47a.49.49,0,0,1,.24-.42l4.11-2.37a.51.51,0,0,1,.48,0,.48.48,0,0,1,.24.42v5.47a.49.49,0,0,1-.24.42l-4.11,2.37A.5.5,0,0,1,102.62,294.41Zm.48-5.68v4.38l3.15-1.82v-4.38Zm3.63,2.83h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.62,312.78a.44.44,0,0,1-.24-.07.46.46,0,0,1-.24-.41v-5.48a.47.47,0,0,1,.24-.41l4.11-2.37a.48.48,0,0,1,.72.41v5.48a.46.46,0,0,1-.24.41l-4.11,2.37A.42.42,0,0,1,102.62,312.78Zm.48-5.68v4.37l3.15-1.82v-4.37Zm3.63,2.83h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8,321.44a.53.53,0,0,1-.24-.06.47.47,0,0,1-.24-.41v-5.48a.46.46,0,0,1,.24-.41l4.11-2.38a.51.51,0,0,1,.48,0,.49.49,0,0,1,.24.42v5.47a.48.48,0,0,1-.24.42L56,321.38A.5.5,0,0,1,55.8,321.44Zm.48-5.68v4.38l3.15-1.82v-4.38Zm3.63,2.83h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,256.65a.48.48,0,0,1-.24-.06.49.49,0,0,1-.24-.42v-5.48a.47.47,0,0,1,.24-.41l4.1-2.37a.46.46,0,0,1,.48,0,.47.47,0,0,1,.24.41v5.48a.46.46,0,0,1-.24.41l-4.11,2.38A.46.46,0,0,1,137,256.65Zm.47-5.68v4.38l3.16-1.83v-4.37Zm3.63,2.83h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,292.94a.47.47,0,0,1-.48-.47V287a.46.46,0,0,1,.24-.41l4.1-2.38a.51.51,0,0,1,.48,0,.49.49,0,0,1,.24.42v5.48a.47.47,0,0,1-.24.41l-4.11,2.37A.46.46,0,0,1,137,292.94Zm.47-5.67v4.37l3.16-1.82v-4.38Zm3.63,2.83h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.79,317.89c-1.9,4-5.52,6-6.89,3.17a.56.56,0,0,1,0-.12,35.44,35.44,0,0,0,3.52-10c.06-.33-.14-.54-.37-.37a11.49,11.49,0,0,0-4.12,9,6,6,0,0,0,.29,1.49l-.18.34a22,22,0,0,1-3.38,4.73,3.17,3.17,0,0,1-2.22,1.17c-.63-.07-1.12-.6-1.08-1.6,0-.27-.35-.57-.5-.09l-.75,2.37c-.11.33-.49,1.94-.8,1.81s0-1.05,0-1.37a1,1,0,0,0-.39-.86c-.09-.05-.27,0-.33.21q-1.16,3.53-2.55,7a53.32,53.32,0,0,1-.13-6.49c0-.3-.41-.51-.58-.06a224.23,224.23,0,0,1-9.19,21.1,65,65,0,0,1,1.62-11.65,11.06,11.06,0,0,0,2.46-3.28A47.73,47.73,0,0,0,158.09,320a.39.39,0,0,0-.11-.4c-1.1-.55-2.21,1.74-2.88,3.21-1,2.16-1.86,4.37-2.64,6.6a79,79,0,0,0-2.29,7.83,1.32,1.32,0,0,1-1.21.22c-.55-.22-.85-.93-.55-2,.13-.45-.37-.63-.54-.13a12.69,12.69,0,0,1-1.14,2.51c0-.81,0-1.62,0-2.44,0-.27-.41-.53-.58-.07a19.43,19.43,0,0,1-2.12,4.4c-.69,1-.56-.46-.52-1,.08-.89.15-1.78.23-2.67,0-.36-.39-.46-.58-.06a57.32,57.32,0,0,1-3.59,6.66,20,20,0,0,1,1-3.84,21.46,21.46,0,0,0,1.15-2.7c.14-.38-.28-.62-.48-.24a24.75,24.75,0,0,0-1.25,2.91,18.35,18.35,0,0,1-3.91,5.21c-.26.22,0,.69.19.5a16.91,16.91,0,0,0,3.08-3.57,19.5,19.5,0,0,0-.5,3.06.27.27,0,0,0,.51.16,57.59,57.59,0,0,0,3.62-6.34,15.4,15.4,0,0,0-.11,2c0,.65.22,1.25.74,1.14s1.16-1.22,1.57-1.94a22.09,22.09,0,0,0,1-2.08c0,.65,0,1.29.05,1.93,0,.27.28.5.5.18a13.23,13.23,0,0,0,1.17-2.08,1.52,1.52,0,0,0,1.5,1.24,2,2,0,0,0,.66-.17c-.4,1.78-.73,3.56-1,5.31a62.21,62.21,0,0,0-.62,7.42c0,.37.4.44.6,0a209.46,209.46,0,0,0,9.26-21,47.84,47.84,0,0,0,.37,6c0,.22.3.3.43,0,1-2.41,1.9-4.85,2.72-7.3a11.93,11.93,0,0,0,0,1.48c.11.32.34.59.67.44s.64-.88.81-1.41c.24-.74.47-1.48.71-2.22a1.58,1.58,0,0,0,2,1.09c1.56-.38,3.15-2.48,4.37-4.36.41-.61.79-1.25,1.15-1.9.82,1.55,2.41,2,4.2,1a9.41,9.41,0,0,0,3.57-4.42C179.4,317.8,179,317.46,178.79,317.89Zm-24.88,9.26c.49-1.27,1-2.53,1.57-3.78.34-.76,1.28-3.05,2-3.11a47.43,47.43,0,0,1-3.68,11.55,18.05,18.05,0,0,1-2.87,4.82c.11-.45.22-.91.34-1.36A76.79,76.79,0,0,1,153.91,327.15Zm20.77-15.49a34.57,34.57,0,0,1-3.05,8.57C171,317.63,172.45,313.71,174.68,311.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,362.76c-8.52,5.45-15.49,9-23.88,11.81a8.65,8.65,0,0,0-3.13,1.51c-1,.84-2.09,1.73-3.13,2.61-.09-.26-.18-.51-.26-.77s-.53-.16-.71.21c-.3.63-.89,1.68-1.4,1.7s-.49-.63-.21-1.16-.31-.81-.61-.37a33,33,0,0,1-2.13,2.82,10.37,10.37,0,0,1,.19-2.84,56.81,56.81,0,0,0,2.65-5.83c.26-.66-.3-.78-.63-.35a15.52,15.52,0,0,0-2.76,6,47.94,47.94,0,0,1-10.27,13.53,18,18,0,0,1-2.13,1.7c-.28.19-.63.39-.87.29s-.28-.81-.21-1.33a28.54,28.54,0,0,1,1.77-5.77,40.36,40.36,0,0,1,5.65-10,30.35,30.35,0,0,1,2-2.3c.75-.78,1.74-1.89,2.49-1.76s1,1.2.93,2.27a17.76,17.76,0,0,1-.85,3.9c-.09.31.23.54.35.15.71-2.21,1.44-4.73.67-6.27a1.26,1.26,0,0,0-1.38-.81,5.62,5.62,0,0,0-2.36,1.72,38,38,0,0,0-7.37,10.87c-1,2.28-4.75,11.22-1.46,10.26a7.4,7.4,0,0,0,2.12-1.4c.78-.64,1.56-1.34,2.32-2.08a45.15,45.15,0,0,0,4.28-4.85,55.72,55.72,0,0,0,4-6.09,9.68,9.68,0,0,0,.1,2.18c0,.28.38.33.6.08.68-.77,1.32-1.6,1.95-2.46a1,1,0,0,0,.68.81c.68.17,1.46-.6,2.06-1.54.06.16.11.32.17.47s.35.17.54,0l3-2.56a8,8,0,0,1,1.52-1.09,11.17,11.17,0,0,1,1.59-.56q3.08-1,6.18-2.29A105.34,105.34,0,0,0,102,367.11a62.54,62.54,0,0,0,5.69-3.75C108.08,363.11,107.79,362.58,107.51,362.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.32,361.06c-.22.12-.07.6.13.48S110.52,360.94,110.32,361.06Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clip--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-2",
    style: {
      opacity: 0.25
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.47,70.89V83.61a10.89,10.89,0,0,1-5,8.64l-24.64,14.22c-1.22.7-1.91,2.11-2.64,3.59a14.32,14.32,0,0,1-1.9,3.11c-1.92,2.17-6.09,4.43-9,5.37a16.94,16.94,0,0,1-3,.68l-1.21.17c-2.69.36-6,.81-8,2L77.27,138a5.08,5.08,0,0,1-2.51.75,3.31,3.31,0,0,1-1.68-.43,4.14,4.14,0,0,1-1.83-3.8V121.78a10.86,10.86,0,0,1,5-8.64l9.68-5.59.13,0a1,1,0,0,1,1,1.74.38.38,0,0,1-.12.1l-9.68,5.59a8.92,8.92,0,0,0-4,6.85V134.5a2.2,2.2,0,0,0,.8,2,2.23,2.23,0,0,0,2.13-.31l28.83-16.65c2.31-1.33,5.89-1.82,8.75-2.2l1.2-.16a17.34,17.34,0,0,0,2.62-.61c2.62-.83,6.5-2.95,8.11-4.77a12.5,12.5,0,0,0,1.6-2.66c.83-1.7,1.7-3.45,3.46-4.46l24.63-14.22a8.92,8.92,0,0,0,4-6.85V70.89a1.73,1.73,0,0,0-2.92-1.69l-8.39,4.85A8.63,8.63,0,0,0,147,72.27l8.41-4.86a3.74,3.74,0,0,1,6,3.48Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.5,71.12h0a2.56,2.56,0,0,1,2.6.25,8.11,8.11,0,0,1,3.66,6.34,2.56,2.56,0,0,1-1.08,2.38h0L90.23,113.84l-5.18-9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65,109.38l61-35.26a7.5,7.5,0,0,0-2.6-2.75,2.72,2.72,0,0,0-.35-.16l-60.1,34.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65,105.12c-2-1.17-3.66-.22-3.66,2.11a8.11,8.11,0,0,0,3.66,6.35c2,1.16,3.66.22,3.66-2.12A8.08,8.08,0,0,0,87.65,105.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,71.79V84.52a10.92,10.92,0,0,1-5,8.64l-24.64,14.22c-1.22.7-1.91,2.1-2.64,3.58a13.75,13.75,0,0,1-1.91,3.11c-1.91,2.17-6.08,4.43-9,5.37a17,17,0,0,1-3,.69c-.37.06-.79.11-1.21.16-2.69.36-6,.82-8,2L78.31,138.88a5,5,0,0,1-2.51.76,3.38,3.38,0,0,1-1.69-.44,4.14,4.14,0,0,1-1.83-3.79V122.68a10.9,10.9,0,0,1,5-8.64L87,108.45l.13,0a1,1,0,0,1,1,1.75.47.47,0,0,1-.12.09l-9.68,5.59a8.92,8.92,0,0,0-4,6.85v12.73a2.18,2.18,0,0,0,.8,2,2.2,2.2,0,0,0,2.13-.31l28.83-16.64c2.31-1.34,5.89-1.82,8.75-2.2l1.2-.17a15.44,15.44,0,0,0,2.62-.61c2.62-.83,6.5-2.94,8.1-4.76a12.85,12.85,0,0,0,1.61-2.67c.83-1.69,1.7-3.44,3.46-4.45l24.63-14.22a8.92,8.92,0,0,0,4-6.85V71.79a2.2,2.2,0,0,0-.8-2,2.18,2.18,0,0,0-2.12.31L149.13,75a8.74,8.74,0,0,0-1.06-1.77l8.41-4.86a3.74,3.74,0,0,1,6,3.47Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M120.05,298l-3.29-10.23c-.36-1.12-1.47-1.18-2.47-.12L61.63,343.48a4.52,4.52,0,0,0-1.16,4l3.29,10.22c.36,1.13,1.47,1.18,2.47.12L118.89,302A4.53,4.53,0,0,0,120.05,298Zm-1.42,3.15L66,357c-.6.64-1.27.61-1.49-.07l-3.29-10.22a2.72,2.72,0,0,1,.7-2.4l52.66-55.82c.6-.64,1.27-.61,1.49.07l3.29,10.23A2.7,2.7,0,0,1,118.63,301.15ZM67.88,341.73a.42.42,0,0,0-.23-.13.4.4,0,0,0-.25.15l-1.05,1.11a.8.8,0,0,0-.2.34,1.58,1.58,0,0,0-.05.41L66,352.86a.22.22,0,0,0,0,.08.18.18,0,0,0,.15.13.31.31,0,0,0,.2-.11l.69-.73a.89.89,0,0,0,.24-.37,2.21,2.21,0,0,0,.05-.29l0-1.62,3-3.19.8.75a.24.24,0,0,0,.16.07c.07,0,.17-.06.29-.2l.69-.72a.69.69,0,0,0,.15-.28.42.42,0,0,0,0-.29l0-.06Zm-.54,6.39L67.4,344l2,1.94Zm8.43-14.42a3.45,3.45,0,0,0-2,1.29l-2.55,2.7a.85.85,0,0,0-.16.28.58.58,0,0,0,0,.29l2.23,6.92c0,.07.07.12.14.12a.27.27,0,0,0,.21-.11l.77-.82a.72.72,0,0,0,.16-.27.58.58,0,0,0,0-.29l-.77-2.39,1.52-1.61a7,7,0,0,0,1.59-2.52,3.78,3.78,0,0,0,.06-2.48C76.73,334,76.32,333.65,75.77,333.7Zm-.13,3.66a3.8,3.8,0,0,1-.79,1.16l-1.47,1.56-.69-2.14,1.47-1.56a2.27,2.27,0,0,1,1-.69c.26-.08.46.08.59.48A1.63,1.63,0,0,1,75.64,337.36ZM115,295.31a2.8,2.8,0,0,0-.62-1,1.2,1.2,0,0,0-.83-.37,2,2,0,0,0-1.06.33,6,6,0,0,0-1.29,1.08l-2.35,2.5a.64.64,0,0,0-.16.28.54.54,0,0,0,0,.28l2.23,6.92a.14.14,0,0,0,.14.12.26.26,0,0,0,.21-.1l2.4-2.55a8.26,8.26,0,0,0,1.13-1.47,7,7,0,0,0,.66-1.5,5.56,5.56,0,0,0,.23-1.49,5.46,5.46,0,0,0-.17-1.46A14.1,14.1,0,0,0,115,295.31Zm-.81,4.54a3.85,3.85,0,0,1-.37.84,4.45,4.45,0,0,1-.64.84l-1.32,1.41-1.55-4.82,1.27-1.36a3.43,3.43,0,0,1,.75-.62,1.08,1.08,0,0,1,.6-.18.72.72,0,0,1,.46.2,1.44,1.44,0,0,1,.32.51,13.41,13.41,0,0,1,.51,1.59,3.19,3.19,0,0,1,.09.77A3,3,0,0,1,114.14,299.85Zm-4.85,5.87a.27.27,0,0,0-.21.11l-3.15,3.34-.57-1.78,2.86-3a.64.64,0,0,0,.16-.28.54.54,0,0,0,0-.28l-.25-.76a.14.14,0,0,0-.14-.12.26.26,0,0,0-.21.1l-2.86,3-.55-1.7,3.07-3.26a.71.71,0,0,0,.16-.28.58.58,0,0,0,0-.29l-.25-.76a.15.15,0,0,0-.14-.12.27.27,0,0,0-.21.11l-4.1,4.35a.85.85,0,0,0-.16.28.54.54,0,0,0,0,.28l2.23,6.92a.17.17,0,0,0,.14.13.31.31,0,0,0,.21-.11l4.18-4.43a.85.85,0,0,0,.16-.28.58.58,0,0,0,0-.29l-.25-.76A.14.14,0,0,0,109.29,305.72Zm-7.54,0v0a.14.14,0,0,0-.14-.12.27.27,0,0,0-.21.11l-.72.76a.77.77,0,0,0-.19.32,1.81,1.81,0,0,0,0,.29l0,6.8-3.24-3.41a.26.26,0,0,0-.16-.07c-.07,0-.15,0-.24.13l-.73.77a.69.69,0,0,0-.15.28.45.45,0,0,0,0,.28v0l0,0,4.31,4.48a.37.37,0,0,0,.22.13c.07,0,.15,0,.26-.15l.76-.81a.84.84,0,0,0,.2-.33,1.76,1.76,0,0,0,0-.42l0-9C101.76,305.81,101.76,305.78,101.75,305.77ZM88.86,325a5.31,5.31,0,0,0,.68-1.81,3.57,3.57,0,0,0-.11-1.67c-.24-.74-.63-1.1-1.18-1.07a3.4,3.4,0,0,0-2,1.3l-2.46,2.6a.69.69,0,0,0-.15.28.54.54,0,0,0,0,.28l2.23,6.92A.16.16,0,0,0,86,332a.31.31,0,0,0,.21-.11l.77-.82a.58.58,0,0,0,.15-.28.46.46,0,0,0,0-.28l-.81-2.5,1.27-1.34,2.05,1.17a.33.33,0,0,0,.19.05c.08,0,.19-.06.31-.19l.81-.86a.58.58,0,0,0,.13-.23.46.46,0,0,0,0-.23.28.28,0,0,0-.07-.09Zm-.78-1a4.29,4.29,0,0,1-.8,1.13l-1.38,1.47-.66-2,1.39-1.46a2.58,2.58,0,0,1,.93-.72c.26-.09.45.06.58.46A1.55,1.55,0,0,1,88.08,324.07Zm-6,3a3.56,3.56,0,0,0-2,1.29L77.51,331a.61.61,0,0,0-.16.27.58.58,0,0,0,0,.29l2.23,6.92a.14.14,0,0,0,.14.12.26.26,0,0,0,.21-.1l.77-.82a.85.85,0,0,0,.16-.28.54.54,0,0,0,0-.28l-.77-2.39,1.52-1.62a6.82,6.82,0,0,0,1.59-2.52,3.91,3.91,0,0,0,.06-2.48C83,327.37,82.6,327,82.05,327Zm-.13,3.66a3.86,3.86,0,0,1-.79,1.16l-1.47,1.57L79,331.29l1.47-1.57a2.45,2.45,0,0,1,.94-.69c.27-.07.47.09.6.49A1.66,1.66,0,0,1,81.92,330.7Zm14.75-14.26c0-.17-.1-.34-.16-.51s-.11-.35-.17-.51-.1-.3-.15-.43a2.74,2.74,0,0,0-.58-.92,1.28,1.28,0,0,0-.82-.36,1.94,1.94,0,0,0-1.06.29,5.28,5.28,0,0,0-1.28,1.05,8.27,8.27,0,0,0-1.15,1.53,6.69,6.69,0,0,0-.65,1.53,5.48,5.48,0,0,0-.23,1.47,5.32,5.32,0,0,0,.16,1.35l.13.46c.05.17.11.34.16.51s.11.35.17.51l.16.43a2.67,2.67,0,0,0,.57.92,1.22,1.22,0,0,0,.81.37,1.93,1.93,0,0,0,1.06-.3,5.58,5.58,0,0,0,1.29-1.06,7.73,7.73,0,0,0,1.14-1.52,6.79,6.79,0,0,0,.67-1.53,5.46,5.46,0,0,0,.22-1.47,4.9,4.9,0,0,0-.16-1.35C96.77,316.76,96.72,316.61,96.67,316.44Zm-1.23,3.43a4,4,0,0,1-.94,1.56,1.89,1.89,0,0,1-1.2.72c-.36,0-.64-.24-.83-.72-.1-.26-.2-.56-.31-.89s-.2-.64-.27-.92a3.07,3.07,0,0,1,0-1.67,4.08,4.08,0,0,1,.94-1.56,1.82,1.82,0,0,1,1.21-.71c.36,0,.64.24.83.72.1.26.2.56.31.89s.19.64.27.92A2.94,2.94,0,0,1,95.44,319.87Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.67,175.06a2.27,2.27,0,0,0-.88-1.09,2.11,2.11,0,0,0-1.34-.27,4.41,4.41,0,0,0-1.71.62l-3.59,2.07a.78.78,0,0,0-.26.3.85.85,0,0,0-.1.4v11.68a.34.34,0,0,0,.1.28.23.23,0,0,0,.26,0l3.66-2.11a7.33,7.33,0,0,0,1.7-1.35,9.2,9.2,0,0,0,1.3-1.79,9.3,9.3,0,0,0,.86-2.09,9.44,9.44,0,0,0,.36-2.25c0-.24,0-.47,0-.67v-1.2c0-.22,0-.44,0-.69A5.31,5.31,0,0,0,97.67,175.06Zm-2.14,5.19c0,.23,0,.47,0,.72a3.46,3.46,0,0,1-1.78,3.11l-1.45.84v-6.87l1.39-.8c1.17-.68,1.79-.34,1.84,1,0,.25,0,.48,0,.7Zm7.21-11.13-1.77,1a.68.68,0,0,0-.26.29.93.93,0,0,0-.11.41v11.67a.33.33,0,0,0,.11.28.21.21,0,0,0,.26,0l1.77-1a.62.62,0,0,0,.26-.29.9.9,0,0,0,.11-.41V169.4a.33.33,0,0,0-.11-.28A.24.24,0,0,0,102.74,169.12Zm-42,30.31A3.16,3.16,0,0,0,61,199a3.74,3.74,0,0,0,.25-.59,5.32,5.32,0,0,0,.21-.79,4.92,4.92,0,0,0,.09-1,4.6,4.6,0,0,0-.16-1.25,1.76,1.76,0,0,0-.54-.9,1.38,1.38,0,0,0-1-.29,3.39,3.39,0,0,0-1.53.55l-4.37,2.52a.68.68,0,0,0-.26.29.88.88,0,0,0-.1.41v11.67a.33.33,0,0,0,.1.28.24.24,0,0,0,.26,0l4.65-2.69A5.36,5.36,0,0,0,60,206.1a6.39,6.39,0,0,0,1-1.44,6.49,6.49,0,0,0,.54-1.57,7.53,7.53,0,0,0,.16-1.54,3.9,3.9,0,0,0-.21-1.42A1.15,1.15,0,0,0,60.74,199.43Zm-4.69-.55,2.1-1.21c.28-.16.48-.18.62-.08a.77.77,0,0,1,.21.63,1.86,1.86,0,0,1-.21.87,1.53,1.53,0,0,1-.62.64l-2.1,1.21ZM58.94,204a1.73,1.73,0,0,1-.65.69l-2.24,1.29v-2.2l2.24-1.3a.61.61,0,0,1,.65-.06.77.77,0,0,1,.24.65A2,2,0,0,1,58.94,204ZM77.32,183.8l-1.78,1a.75.75,0,0,0-.26.29.91.91,0,0,0-.1.41V197.2a.33.33,0,0,0,.1.28.21.21,0,0,0,.26,0l1.78-1a.61.61,0,0,0,.25-.29.79.79,0,0,0,.11-.41V184.08a.31.31,0,0,0-.11-.28A.23.23,0,0,0,77.32,183.8Zm9.92,4-4.14,2.39V181a.33.33,0,0,0-.1-.28.22.22,0,0,0-.26,0l-1.78,1a.66.66,0,0,0-.25.29.79.79,0,0,0-.11.41v11.67a.31.31,0,0,0,.11.28c.07.06.15.05.25,0l6.28-3.63a.68.68,0,0,0,.26-.29.88.88,0,0,0,.1-.4v-1.92a.33.33,0,0,0-.1-.28A.24.24,0,0,0,87.24,187.83Zm-15.25-1-1.77,1a.71.71,0,0,0-.26.3.86.86,0,0,0-.11.4v7.14a4.41,4.41,0,0,1-.4,1.93A3,3,0,0,1,68.24,199c-.54.32-.95.35-1.22.09a2.05,2.05,0,0,1-.4-1.47v-7.14a.34.34,0,0,0-.1-.28.23.23,0,0,0-.26,0l-1.78,1a.69.69,0,0,0-.25.3.76.76,0,0,0-.11.4v7.21a6,6,0,0,0,.29,2,2.16,2.16,0,0,0,.85,1.13,1.92,1.92,0,0,0,1.3.23,4.88,4.88,0,0,0,1.68-.63,7.93,7.93,0,0,0,1.66-1.3,8.27,8.27,0,0,0,1.31-1.74,8.64,8.64,0,0,0,.85-2.1,9.18,9.18,0,0,0,.3-2.38v-7.21a.35.35,0,0,0-.11-.28A.23.23,0,0,0,72,186.88Zm99-57.15-1.57.91a1.06,1.06,0,0,0-.41.43,2.8,2.8,0,0,0-.17.4l-2.2,6.27-2.2-3.74a.81.81,0,0,0-.17-.19c-.09-.08-.23-.07-.41,0l-1.57.91a.62.62,0,0,0-.26.29.9.9,0,0,0-.11.41v11.67a.33.33,0,0,0,.11.28.24.24,0,0,0,.26,0l1.77-1a.68.68,0,0,0,.26-.29.93.93,0,0,0,.11-.41v-6l1.27,2.25a.85.85,0,0,0,.19.19c.07.06.18.05.32,0l.86-.5a.75.75,0,0,0,.32-.34,2.64,2.64,0,0,0,.18-.4l1.28-3.72v6a.31.31,0,0,0,.11.28.21.21,0,0,0,.25,0l1.78-1a.68.68,0,0,0,.26-.29.9.9,0,0,0,.11-.41V130a.33.33,0,0,0-.11-.28A.22.22,0,0,0,171,129.73Zm5.42-3.13-1.77,1a.68.68,0,0,0-.26.29.9.9,0,0,0-.11.41V140a.33.33,0,0,0,.11.28.22.22,0,0,0,.26,0l1.77-1a.62.62,0,0,0,.26-.29.9.9,0,0,0,.11-.41V126.88a.33.33,0,0,0-.11-.28A.24.24,0,0,0,176.39,126.6Zm10.51-5.92a.23.23,0,0,0-.26,0l-7.28,4.2a.68.68,0,0,0-.26.29.93.93,0,0,0-.11.41v1.91a.32.32,0,0,0,.11.28.21.21,0,0,0,.26,0l2.38-1.38v9.27a.32.32,0,0,0,.11.28.21.21,0,0,0,.26,0l1.78-1a.69.69,0,0,0,.25-.3.78.78,0,0,0,.11-.4V125l2.39-1.38a.78.78,0,0,0,.26-.3.85.85,0,0,0,.1-.4V121A.34.34,0,0,0,186.9,120.68Zm-29.19,24.46a6.82,6.82,0,0,0,1.2-2,7.17,7.17,0,0,0,.42-2.5,4.34,4.34,0,0,0-.27-1.68,1.47,1.47,0,0,0-.76-.85,1.91,1.91,0,0,0-1.2-.07,5.8,5.8,0,0,0-1.59.67l-3.68,2.12a.83.83,0,0,0-.26.29.91.91,0,0,0-.1.41v11.67a.35.35,0,0,0,.1.29.23.23,0,0,0,.26,0l1.78-1a.78.78,0,0,0,.26-.3.85.85,0,0,0,.1-.4v-3.87l1.25-.72,1.51,3a.73.73,0,0,0,.18.22c.07.06.2,0,.38-.06l1.85-1.07a.53.53,0,0,0,.21-.23.75.75,0,0,0,.09-.34.53.53,0,0,0,0-.17Zm-1.26-1.84a3,3,0,0,1-.94.84L154,145v-2.67l1.54-.89a1.4,1.4,0,0,1,.94-.25c.25,0,.37.32.37.83A2,2,0,0,1,156.45,143.3ZM113.6,162.86l-1.78,1a.91.91,0,0,0-.36.7v6.11l-3.1-4.39a.68.68,0,0,0-.19-.15.4.4,0,0,0-.37,0l-1.41.82a.68.68,0,0,0-.26.29.93.93,0,0,0-.11.41v11.67a.33.33,0,0,0,.11.28.21.21,0,0,0,.26,0l1.78-1a.67.67,0,0,0,.25-.29.79.79,0,0,0,.11-.41v-6.1l3.1,4.38a.45.45,0,0,0,.19.15.37.37,0,0,0,.37-.05l1.41-.81a.78.78,0,0,0,.26-.3.89.89,0,0,0,.11-.4V163.13a.35.35,0,0,0-.11-.28A.23.23,0,0,0,113.6,162.86Zm34.93-10.41-4.29,2.47v-2l3.88-2.24a.75.75,0,0,0,.26-.29.91.91,0,0,0,.1-.41V148a.31.31,0,0,0-.1-.27.21.21,0,0,0-.26,0L144.24,150v-1.95l4.18-2.41a.69.69,0,0,0,.25-.3.78.78,0,0,0,.11-.4V143a.31.31,0,0,0-.11-.28.23.23,0,0,0-.25,0l-6.32,3.65a.83.83,0,0,0-.26.29.93.93,0,0,0-.11.41v11.67a.32.32,0,0,0,.11.28.21.21,0,0,0,.26,0l6.43-3.71a.73.73,0,0,0,.25-.29.82.82,0,0,0,.11-.41v-1.91a.33.33,0,0,0-.11-.29A.21.21,0,0,0,148.53,152.45Zm-23.91,9.1-3.28,1.9a.68.68,0,0,0-.26.29.9.9,0,0,0-.11.41v1.91a.32.32,0,0,0,.11.28.21.21,0,0,0,.26,0l1.14-.66a3.5,3.5,0,0,1-.14,1,3.13,3.13,0,0,1-.37.83,3.06,3.06,0,0,1-.54.65,3.83,3.83,0,0,1-.66.5,1.83,1.83,0,0,1-.77.27.72.72,0,0,1-.51-.17,1.08,1.08,0,0,1-.3-.49,3.18,3.18,0,0,1-.13-.72c0-.16,0-.37,0-.65s0-.56,0-.86,0-.58,0-.86a5.94,5.94,0,0,1,0-.67,6.56,6.56,0,0,1,.14-.87,3.63,3.63,0,0,1,.29-.84,3.11,3.11,0,0,1,.51-.75,2.66,2.66,0,0,1,.77-.62,1.45,1.45,0,0,1,1-.3.91.91,0,0,1,.51.3l.23.19c.07.07.18.06.32,0l1.8-1a.74.74,0,0,0,.3-.57,2.32,2.32,0,0,0-.33-1.1,1.87,1.87,0,0,0-.83-.77,2.36,2.36,0,0,0-1.28-.2,4.26,4.26,0,0,0-1.71.62,7.55,7.55,0,0,0-1.75,1.39,9.34,9.34,0,0,0-1.31,1.82,10,10,0,0,0-.83,2,8.57,8.57,0,0,0-.33,2.08c0,.53,0,1.07,0,1.64s0,1.09,0,1.57a5,5,0,0,0,.34,1.7,2.2,2.2,0,0,0,.83,1.08,2,2,0,0,0,1.31.3,4.14,4.14,0,0,0,1.74-.61,7.84,7.84,0,0,0,1.66-1.31,8.87,8.87,0,0,0,1.33-1.75,9.41,9.41,0,0,0,.9-2.08,8.3,8.3,0,0,0,.32-2.27v-2.31a.31.31,0,0,0-.11-.28A.23.23,0,0,0,124.62,161.55Zm13.78-12a1.83,1.83,0,0,0-1.18-.11,5.09,5.09,0,0,0-1.56.64l-3.87,2.24a.62.62,0,0,0-.26.29.89.89,0,0,0-.11.4v11.68a.35.35,0,0,0,.11.28.23.23,0,0,0,.26,0l1.77-1a.74.74,0,0,0,.26-.29.93.93,0,0,0,.11-.41v-3.69l1.73-1a7.58,7.58,0,0,0,1.56-1.17A7.19,7.19,0,0,0,138.4,156a6.72,6.72,0,0,0,.75-1.76,7.28,7.28,0,0,0,.27-2,4.42,4.42,0,0,0-.27-1.69A1.63,1.63,0,0,0,138.4,149.59Zm-1.86,5.34a2.82,2.82,0,0,1-.94.88l-1.67,1v-2.86l1.67-1a1.19,1.19,0,0,1,.94-.21c.25.08.37.37.37.88A2.23,2.23,0,0,1,136.54,154.93Z",
    style: {
      fill: "#242424"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Building--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--building--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wall--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.82 399.78 465.8 358.8 465.84 225.56 394.86 266.54 394.82 399.78",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.82 399.78 465.8 358.8 465.84 225.56 394.86 266.54 394.82 399.78",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "394.82 413.91 394.82 404.01 465.8 363.03 465.8 372.93 394.82 413.91",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.82 413.91 394.82 404.01 465.8 363.03 465.8 372.93 394.82 413.91",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "394.82 413.91 394.82 404.01 465.8 363.03 465.8 372.93 394.82 413.91"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--wall--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.82 399.78 299.36 344.66 299.4 211.43 394.86 266.54 394.82 399.78",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.82 399.78 299.36 344.66 299.4 211.43 394.86 266.54 394.82 399.78",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "394.82 413.91 394.82 404.01 299.36 348.9 299.36 358.8 394.82 413.91",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "394.82 413.91 394.82 404.01 299.36 348.9 299.36 358.8 394.82 413.91"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cornice--inject-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "394.82 401.19 468.25 358.8 468.25 363.03 394.82 405.43 394.82 401.19",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "394.82 401.19 468.25 358.8 468.25 363.03 394.82 405.43 394.82 401.19",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "296.92 344.66 296.92 348.9 394.82 405.43 394.82 401.19 296.92 344.66",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "296.92 344.66 296.92 348.9 394.82 405.43 394.82 401.19 296.92 344.66",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "299.36 343.25 299.36 344.66 394.82 399.78 467.02 358.09 468.25 358.8 394.82 401.19 296.92 344.66 299.36 343.25",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "299.36 343.25 299.36 344.66 394.82 399.78 467.02 358.09 468.25 358.8 394.82 401.19 296.92 344.66 299.36 343.25",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "394.82 401.19 394.82 399.78 465.8 358.79 465.8 357.38 468.25 358.8 394.82 401.19",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "394.82 401.19 394.82 399.78 465.8 358.79 465.8 357.38 468.25 358.8 394.82 401.19",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stairs--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "332.4 365.15 332.4 369.39 333.63 370.1 333.63 378.58 320.17 386.35 320.17 383.52 322.62 382.11 322.62 379.29 325.06 377.87 325.06 375.05 327.51 373.63 327.51 370.81 329.96 369.39 329.96 366.57 332.4 365.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316 354.27 333.63 364.45 329.96 366.57 312.32 356.39 316 354.27",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.32 359.22 329.96 369.39 327.51 370.81 309.87 360.63 312.32 359.22",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.87 363.46 327.51 373.63 325.06 375.05 307.42 364.87 309.87 363.46",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.42 367.7 325.06 377.87 322.62 379.29 304.98 369.11 307.42 367.7",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.98 371.94 322.62 382.11 320.17 383.52 302.53 373.35 304.98 371.94",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.32 356.39 329.96 366.57 329.96 369.39 312.32 359.22 312.32 356.39",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.87 360.63 327.51 370.81 327.51 373.63 309.87 363.46 309.87 360.63",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.42 364.87 325.06 375.05 325.06 377.87 307.42 367.7 307.42 364.87",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.53 373.35 320.17 383.52 320.17 386.35 302.53 376.17 302.53 373.35",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.97 369.11 322.62 379.28 322.62 382.11 304.98 371.94 304.97 369.11",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "367.49 358.56 367.49 375.32 380.13 382.62 380.13 365.86 367.49 358.56",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.49 358.56 367.49 375.32 380.13 382.62 380.13 365.86 367.49 358.56"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "369.19 374.19 380.13 380.5 380.13 365.86 369.19 359.54 369.19 374.19",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "369.19 374.19 380.13 380.5 380.13 365.86 369.19 359.54 369.19 374.19",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "367.49 358.56 369.19 359.54 369.19 374.19 367.49 375.32 367.49 358.56",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.71 383.53 365.91 374.41 365.13 374.86 380.93 383.99 381.71 383.53",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "381.71 383.53 365.91 374.41 365.13 374.86 380.93 383.99 381.71 383.53",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "380.93 383.99 380.93 385.81 365.13 376.69 365.13 374.86 380.93 383.99",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "380.93 383.99 380.93 385.81 365.13 376.69 365.13 374.86 380.93 383.99",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "381.71 383.53 381.71 385.36 380.93 385.81 380.93 383.99 381.71 383.53",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "381.71 383.53 381.71 385.36 380.93 385.81 380.93 383.99 381.71 383.53",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "375.01 377.54 375.01 362.9 374.09 362.37 374.09 377.01 375.01 377.54",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "345.43 345.82 345.43 362.58 358.07 369.89 358.07 353.12 345.43 345.82",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "345.43 345.82 345.43 362.58 358.07 369.89 358.07 353.12 345.43 345.82"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "347.13 361.45 358.07 367.77 358.07 353.12 347.13 346.81 347.13 361.45",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "347.13 361.45 358.07 367.77 358.07 353.12 347.13 346.81 347.13 361.45",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "345.43 345.82 347.13 346.81 347.13 361.45 345.43 362.58 345.43 345.82",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.65 370.8 343.85 361.67 343.07 362.12 358.87 371.25 359.65 370.8",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.65 370.8 343.85 361.67 343.07 362.12 358.87 371.25 359.65 370.8",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "358.87 371.25 358.87 373.07 343.07 363.95 343.07 362.12 358.87 371.25",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "358.87 371.25 358.87 373.07 343.07 363.95 343.07 362.12 358.87 371.25",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "359.65 370.8 359.65 372.62 358.87 373.07 358.87 371.25 359.65 370.8",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.65 370.8 359.65 372.62 358.87 373.07 358.87 371.25 359.65 370.8",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "352.95 364.81 352.95 350.16 352.03 349.63 352.03 364.28 352.95 364.81",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Balcony--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-2",
    style: {
      opacity: 0.15
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.09 311.33 337.75 326.15 337.75 320.33 312.09 305.51 312.09 311.33"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "337.75 320.34 312.09 305.51 305.27 309.45 330.93 324.27 337.75 320.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.75 320.34 337.75 321.32 330.93 325.26 330.93 324.27 337.75 320.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.93 324.27 305.27 309.45 305.27 310.44 330.93 325.26 330.93 324.27",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Door--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "316.37 279.29 316.37 307.98 333.7 317.99 333.71 289.3 316.37 279.29",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.74 307.07 315.79 308.32 333.71 318.67 333.7 316.28 317.74 307.07",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "317.74 307.07 315.79 308.32 333.71 318.67 333.7 316.28 317.74 307.07",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "317.74 307.07 333.7 316.28 333.71 289.3 317.74 280.08 317.74 307.07",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "317.74 307.07 333.7 316.28 333.71 289.3 317.74 280.08 317.74 307.07",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.74 280.08 317.75 282.75 333.71 291.97 333.71 289.3 317.74 280.08"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "324.44 283.94 325.04 284.29 325.04 312.98 324.44 312.64 324.44 283.94",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.44 283.94 325.04 284.29 325.04 312.98 324.44 312.64 324.44 283.94"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "325.04 284.29 325.04 312.98 325.64 312.64 325.64 284.63 325.04 284.29",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "325.04 284.29 325.04 312.98 325.64 312.64 325.64 284.63 325.04 284.29"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "316.37 307.98 315.79 308.32 315.79 278.95 316.37 279.29 316.37 307.98",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "316.37 307.98 315.79 308.32 315.79 278.95 316.37 279.29 316.37 307.98",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.37 307.98 315.79 308.32 315.79 278.95 316.37 279.29 316.37 307.98"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "315.79 308.32 313.48 306.99 313.48 274.95 336.02 287.96 336.02 320 333.71 318.67 333.71 289.3 315.79 278.95 315.79 308.32",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "315.79 308.32 313.48 306.99 313.48 274.95 336.02 287.96 336.02 320 333.71 318.67 333.71 289.3 315.79 278.95 315.79 308.32",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "313.48 274.95 336.02 287.96 336.6 287.63 314.05 274.61 313.48 274.95",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "313.48 274.95 336.02 287.96 336.6 287.63 314.05 274.61 313.48 274.95",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "336.02 320 336.02 287.96 336.6 287.63 336.6 319.67 336.02 320",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "336.6 287.63 336.6 319.67 336.02 320 336.02 287.96",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Railing--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.59,297.62a.44.44,0,0,1,.21-.37l.21-.11h0l6.54-3.7h0a.16.16,0,0,1,.15,0,.67.67,0,0,1,.25.54.27.27,0,0,1-.09.24h0l-.2.11h0l-5.79,3.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.21,298.78l6.56-3.78a.1.1,0,0,1,.09,0,.26.26,0,0,1,.12.21s0,.07,0,.08l-6.75,3.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.21 300.19 312.98 296.27 312.98 304.75 306.21 308.67 306.21 300.19"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "331.06 314.54 306.21 300.19 306.21 308.67 331.06 323.01 331.06 314.54"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.81 314.54 337.88 310.44 337.88 318.92 330.81 323.01 330.81 314.54"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M330.92,313.06l6.75-3.89a.08.08,0,0,1,.09,0,.24.24,0,0,1,.12.21.1.1,0,0,1,0,.08l-6.75,3.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.83,306.06l-12.39-7.14s-.05,0-.08,0a.25.25,0,0,0-.13.21.1.1,0,0,0,0,.08l12.38,7.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.64,304.86v11.65s0,.05.05.07a.25.25,0,0,0,.24,0s.06,0,.06-.07V304.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,313.06l-12-6.93a.1.1,0,0,0-.09,0,.27.27,0,0,0-.12.22.1.1,0,0,0,0,.08l12,6.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.12,297.65V309.3a.1.1,0,0,0,.05.07.28.28,0,0,0,.25,0,.1.1,0,0,0,.05-.07V297.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.76,311.87v11.65a.1.1,0,0,0,.06.07.25.25,0,0,0,.24,0,.1.1,0,0,0,.05-.07V311.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.86,297.62l24.08,13.89,6.54-3.7h0a.16.16,0,0,1,.15,0,.67.67,0,0,1,.25.54.27.27,0,0,1-.09.24h0l-6.64,3.75a.37.37,0,0,1-.21.06.42.42,0,0,1-.21-.06L305.8,298a.41.41,0,0,1-.21-.36",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--balcony--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-2",
    style: {
      opacity: 0.15
    }
  }, _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "312.09 268.43 337.75 283.25 337.75 277.44 312.09 262.61 312.09 268.43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "337.75 277.44 312.09 262.61 305.27 266.55 330.93 281.37 337.75 277.44",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.75 277.44 337.75 278.42 330.93 282.36 330.93 281.37 337.75 277.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.93 281.37 305.27 266.55 305.27 267.53 330.93 282.36 330.93 281.37",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "316.37 236.39 316.37 265.08 333.7 275.09 333.71 246.4 316.37 236.39",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.74 264.17 315.79 265.42 333.71 275.77 333.7 273.38 317.74 264.17",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "317.74 264.17 315.79 265.42 333.71 275.77 333.7 273.38 317.74 264.17",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "317.74 264.17 333.7 273.38 333.71 246.4 317.74 237.18 317.74 264.17",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "317.75 264.17 333.7 273.38 333.71 246.4 317.75 237.18 317.75 264.17",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.75 237.18 317.75 239.85 333.71 249.07 333.71 246.4 317.75 237.18"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "324.44 241.04 325.04 241.39 325.04 270.08 324.44 269.74 324.44 241.04",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "324.44 241.04 325.04 241.39 325.04 270.08 324.44 269.74 324.44 241.04"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "325.04 241.39 325.04 270.08 325.64 269.74 325.64 241.73 325.04 241.39",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "325.04 241.39 325.04 270.08 325.64 269.74 325.64 241.73 325.04 241.39"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "316.37 265.08 315.79 265.42 315.79 236.05 316.37 236.39 316.37 265.08",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "316.37 265.08 315.79 265.42 315.79 236.05 316.37 236.39 316.37 265.08",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.37 265.08 315.79 265.42 315.79 236.05 316.37 236.39 316.37 265.08"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "315.79 265.42 313.48 264.08 313.48 232.04 336.02 245.06 336.02 277.1 333.71 275.77 333.71 246.4 315.79 236.05 315.79 265.42",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "315.79 265.42 313.48 264.08 313.48 232.04 336.02 245.06 336.02 277.1 333.71 275.77 333.71 246.4 315.79 236.05 315.79 265.42",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "313.48 232.04 336.02 245.06 336.6 244.73 314.05 231.71 313.48 232.04",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "313.48 232.04 336.02 245.06 336.6 244.73 314.05 231.71 313.48 232.04",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "336.02 277.1 336.02 245.06 336.6 244.73 336.6 276.77 336.02 277.1",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "336.6 244.73 336.6 276.77 336.02 277.1 336.02 245.06",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.59,254.71a.42.42,0,0,1,.21-.36l.21-.11h0l6.55-3.7h0a.16.16,0,0,1,.15,0,.66.66,0,0,1,.25.53.32.32,0,0,1-.09.25h0l-.2.11h0l-5.8,3.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.21,255.88l6.56-3.78a.1.1,0,0,1,.09,0,.26.26,0,0,1,.12.21s0,.07,0,.08l-6.75,3.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.21 257.29 312.98 253.37 312.98 261.85 306.21 265.77 306.21 257.29"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "331.06 271.64 306.21 257.29 306.21 265.77 331.06 280.11 331.06 271.64"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.8 271.64 337.88 267.54 337.88 276.01 330.8 280.11 330.8 271.64"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M330.92,270.16l6.75-3.89s.05,0,.09,0a.3.3,0,0,1,.12.22.1.1,0,0,1,0,.08l-6.75,3.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.82,263.16,306.44,256s-.05,0-.09,0a.3.3,0,0,0-.12.22.08.08,0,0,0,0,.08l12.38,7.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.64,262v11.65s0,.05.05.07a.25.25,0,0,0,.24,0s.05,0,.05-.07V262Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,270.16l-12-6.93a.06.06,0,0,0-.08,0,.29.29,0,0,0-.13.22.08.08,0,0,0,0,.07l12,6.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.12,254.75V266.4a.1.1,0,0,0,.05.07.25.25,0,0,0,.24,0,.08.08,0,0,0,0-.07V254.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.76,269v11.65a.1.1,0,0,0,.05.07.28.28,0,0,0,.25,0,.1.1,0,0,0,.05-.07V269Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.85,254.72l24.08,13.89,6.55-3.7h0a.16.16,0,0,1,.15,0,.67.67,0,0,1,.25.54.3.3,0,0,1-.09.24h0l-6.64,3.75a.4.4,0,0,1-.42,0L305.8,255.08a.42.42,0,0,1-.21-.37",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--balcony--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-2",
    style: {
      opacity: 0.15
    }
  }, _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "355.63 336.37 381.29 351.19 381.29 345.37 355.63 330.55 355.63 336.37"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "381.29 345.38 355.63 330.55 348.81 334.49 374.46 349.31 381.29 345.38",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.29 345.38 381.29 346.36 374.46 350.3 374.46 349.31 381.29 345.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.46 349.31 348.81 334.49 348.81 335.47 374.46 350.3 374.46 349.31",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.91 304.33 359.91 333.02 377.24 343.03 377.25 314.34 359.91 304.33",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.28 332.1 359.32 333.36 377.25 343.7 377.24 341.32 361.28 332.1",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "361.28 332.1 359.32 333.36 377.25 343.7 377.24 341.32 361.28 332.1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "361.28 332.1 377.24 341.32 377.25 314.34 361.28 305.12 361.28 332.1",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "361.28 332.11 377.24 341.32 377.25 314.34 361.28 305.12 361.28 332.11",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "361.28 305.12 361.28 307.79 377.25 317.01 377.25 314.34 361.28 305.12"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "367.97 308.98 368.58 309.33 368.58 338.02 367.97 337.68 367.97 308.98",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.97 308.98 368.58 309.33 368.58 338.02 367.97 337.68 367.97 308.98"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "368.58 309.33 368.58 338.02 369.18 337.68 369.18 309.67 368.58 309.33",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "368.58 309.33 368.58 338.02 369.18 337.68 369.18 309.67 368.58 309.33"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "359.91 333.02 359.32 333.36 359.32 303.99 359.91 304.33 359.91 333.02",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.91 333.02 359.32 333.36 359.32 303.99 359.91 304.33 359.91 333.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "359.91 333.02 359.32 333.36 359.32 303.99 359.91 304.33 359.91 333.02"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "359.32 333.36 357.01 332.02 357.01 299.99 379.56 313 379.56 345.04 377.25 343.7 377.25 314.34 359.33 303.99 359.32 333.36",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.32 333.36 357.01 332.02 357.01 299.99 379.56 313 379.56 345.04 377.25 343.7 377.25 314.34 359.33 303.99 359.32 333.36",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "357.01 299.99 379.56 313 380.13 312.67 357.59 299.65 357.01 299.99",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.01 299.99 379.56 313 380.13 312.67 357.59 299.65 357.01 299.99",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "379.56 345.04 379.56 313 380.13 312.67 380.13 344.71 379.56 345.04",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "380.13 312.67 380.13 344.71 379.56 345.04 379.56 313",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.13,322.65a.42.42,0,0,1,.21-.36l.21-.12h0l6.54-3.7h0a.16.16,0,0,1,.15,0,.66.66,0,0,1,.25.53.29.29,0,0,1-.09.25h0l-.2.11h0l-5.8,3.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.75,323.82l6.56-3.78a.08.08,0,0,1,.09,0,.26.26,0,0,1,.12.21.1.1,0,0,1,0,.08l-6.75,3.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "349.75 325.23 356.52 321.31 356.52 329.79 349.75 333.71 349.75 325.23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "374.6 339.57 349.75 325.23 349.75 333.71 374.6 348.05 374.6 339.57"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "374.35 339.57 381.42 335.48 381.42 343.95 374.35 348.05 374.35 339.57"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M374.46,338.09l6.75-3.88s.05,0,.09,0a.27.27,0,0,1,.12.22.08.08,0,0,1,0,.08l-6.75,3.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.37,331.1,350,324s-.05,0-.09,0a.3.3,0,0,0-.12.22.12.12,0,0,0,0,.08l12.38,7.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.18,329.9v11.65s0,.05.05.07a.25.25,0,0,0,.24,0s0,0,0-.07V329.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.49,338.09l-12-6.93a.08.08,0,0,0-.08,0,.27.27,0,0,0-.12.22.08.08,0,0,0,0,.07l12,6.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.66,322.69v11.65a.1.1,0,0,0,0,.07.28.28,0,0,0,.25,0,.1.1,0,0,0,.05-.07V322.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.3,336.91v11.64a.1.1,0,0,0,.05.08.36.36,0,0,0,.25,0,.1.1,0,0,0,0-.08V336.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.39,322.66l24.09,13.89,6.54-3.7h0a.16.16,0,0,1,.15,0,.67.67,0,0,1,.25.54.3.3,0,0,1-.09.24h0l-6.64,3.75a.39.39,0,0,1-.21.06.42.42,0,0,1-.21-.06L349.34,323a.44.44,0,0,1-.21-.37",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--balcony--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-2",
    style: {
      opacity: 0.15
    }
  }, _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "355.63 293.47 381.29 308.29 381.29 302.47 355.63 287.65 355.63 293.47"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "381.29 302.47 355.63 287.65 348.81 291.59 374.46 306.41 381.29 302.47",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.29 302.47 381.29 303.46 374.47 307.4 374.46 306.41 381.29 302.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.46 306.41 348.81 291.59 348.81 292.57 374.47 307.4 374.46 306.41",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.91 261.43 359.91 290.12 377.24 300.13 377.25 271.44 359.91 261.43",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.28 289.2 359.33 290.46 377.25 300.8 377.24 298.42 361.28 289.2",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "361.28 289.2 359.33 290.46 377.25 300.8 377.24 298.42 361.28 289.2",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "361.28 289.2 377.24 298.42 377.25 271.44 361.28 262.22 361.28 289.2",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9500000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "361.28 289.2 377.24 298.42 377.25 271.44 361.28 262.22 361.28 289.2",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "361.28 262.22 361.28 264.89 377.25 274.11 377.25 271.44 361.28 262.22"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "367.97 266.08 368.58 266.43 368.58 295.12 367.97 294.78 367.97 266.08",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.97 266.08 368.58 266.43 368.58 295.12 367.97 294.78 367.97 266.08"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "368.58 266.43 368.58 295.12 369.18 294.77 369.18 266.77 368.58 266.43",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "368.58 266.43 368.58 295.12 369.18 294.77 369.18 266.77 368.58 266.43"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "359.91 290.12 359.33 290.46 359.33 261.09 359.91 261.43 359.91 290.12",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.91 290.12 359.33 290.46 359.33 261.09 359.91 261.43 359.91 290.12",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "359.91 290.12 359.33 290.46 359.33 261.09 359.91 261.43 359.91 290.12"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "359.32 290.46 357.01 289.12 357.01 257.08 379.56 270.1 379.56 302.14 377.25 300.8 377.25 271.44 359.33 261.09 359.32 290.46",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "359.32 290.46 357.01 289.12 357.01 257.08 379.56 270.1 379.56 302.14 377.25 300.8 377.25 271.44 359.33 261.09 359.32 290.46",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "357.01 257.08 379.56 270.1 380.13 269.77 357.59 256.75 357.01 257.08",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "357.01 257.08 379.56 270.1 380.13 269.77 357.59 256.75 357.01 257.08",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "379.56 302.14 379.56 270.1 380.13 269.77 380.13 301.81 379.56 302.14",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "380.13 269.77 380.13 301.81 379.56 302.14 379.56 270.1",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.13,279.75a.41.41,0,0,1,.21-.36l.2-.12h0l6.55-3.7h0s.09,0,.15,0a.66.66,0,0,1,.25.53.32.32,0,0,1-.09.25h0l-.2.12h0l-5.8,3.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.74,280.92l6.57-3.78s.05,0,.09,0a.27.27,0,0,1,.12.21.08.08,0,0,1,0,.08l-6.75,3.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "349.75 282.33 356.52 278.41 356.52 286.88 349.75 290.81 349.75 282.33"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--railing--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "374.6 296.67 349.75 282.33 349.75 290.81 374.6 305.15 374.6 296.67"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "374.34 296.67 381.42 292.57 381.42 301.05 374.34 305.15 374.34 296.67"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M374.46,295.19l6.75-3.89a.08.08,0,0,1,.08,0,.29.29,0,0,1,.13.22.08.08,0,0,1,0,.07l-6.75,3.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.36,288.19,350,281.05a.1.1,0,0,0-.09,0,.27.27,0,0,0-.12.21s0,.07,0,.08l12.38,7.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.17,287v11.65s0,.05.05.07a.28.28,0,0,0,.25,0s0,0,0-.07V287Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.49,295.19l-12-6.93a.1.1,0,0,0-.09,0,.3.3,0,0,0-.12.21.09.09,0,0,0,0,.08l12,6.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.66,279.79v11.65a.08.08,0,0,0,0,.07.25.25,0,0,0,.24,0,.08.08,0,0,0,.05-.07V279.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.3,294v11.64s0,.05.05.07a.28.28,0,0,0,.25,0s0,0,0-.07V294Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.39,279.76l24.08,13.89L381,290h0a.14.14,0,0,1,.14,0,.67.67,0,0,1,.26.54.3.3,0,0,1-.09.24h0l-6.64,3.75a.42.42,0,0,1-.21.06.39.39,0,0,1-.21-.06l-24.92-14.38a.44.44,0,0,1-.21-.37",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Roof--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--roof--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--roof--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "297.32 211.43 370.35 169.19 467.88 225.56 394.85 267.72 297.32 211.43",
    style: {
      fill: "#242424"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--roof--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "297.32 211.43 370.35 169.19 467.88 225.56 394.85 267.72 297.32 211.43",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "370.38 173.27 370.38 176.1 306.74 212.84 304.29 211.43 370.38 173.27",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.38 173.27 370.38 176.1 306.74 212.84 304.29 211.43 370.38 173.27"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "370.38 173.27 460.94 225.56 458.49 226.97 370.38 176.1 370.38 173.27",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.74 212.84 370.38 176.1 458.49 226.97 394.86 263.71 306.74 212.84",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "306.74 212.84 370.38 176.1 458.49 226.97 394.86 263.71 306.74 212.84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "433.39 214.13 455.69 227 440.01 236.06 417.7 223.19 433.39 214.13"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "433.24 211.22 441.34 215.9 430 222.44 421.91 217.77 433.24 211.22",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.34 215.9 441.34 220.57 430 227.11 430 222.44 441.34 215.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.91 217.77 421.91 222.44 430 227.11 430 222.44 421.91 217.77",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.9,214.36c1.47.85,1.47,2.22,0,3.07a5.87,5.87,0,0,1-5.32,0c-1.47-.85-1.47-2.22,0-3.07A5.87,5.87,0,0,1,435.9,214.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.49,215.24c.69.36.69.95,0,1.32a3,3,0,0,1-2.49,0c-.69-.37-.69-1,0-1.33A3,3,0,0,1,434.49,215.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.88,227a.4.4,0,0,0,.4-.4V224l1.42-.82a.4.4,0,0,0,.14-.55.39.39,0,0,0-.54-.14l-1.62.93a.4.4,0,0,0-.2.35v2.8A.4.4,0,0,0,425.88,227Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.53,225.64a.4.4,0,0,0,.4-.4v-2.57l1.42-.82a.39.39,0,0,0,.14-.54.39.39,0,0,0-.54-.15l-1.62.93a.43.43,0,0,0-.2.35v2.8A.4.4,0,0,0,423.53,225.64Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.58 217.76 452.67 222.44 441.34 228.98 433.24 224.31 444.58 217.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.67 222.44 452.67 227.11 441.34 233.66 441.34 228.98 452.67 222.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.24 224.31 433.24 228.98 441.34 233.66 441.34 228.98 433.24 224.31",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.24,220.9c1.47.85,1.47,2.23,0,3.08a5.9,5.9,0,0,1-5.32,0c-1.47-.84-1.47-2.22,0-3.07A5.93,5.93,0,0,1,447.24,220.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.82,221.78c.69.36.69,1,0,1.32a2.93,2.93,0,0,1-2.49,0c-.69-.37-.69-1,0-1.32A2.93,2.93,0,0,1,445.82,221.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.21,233.54a.4.4,0,0,0,.4-.4v-2.57l1.42-.82a.4.4,0,1,0-.4-.69L437,230a.41.41,0,0,0-.19.35v2.8A.39.39,0,0,0,437.21,233.54Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.86,232.19a.4.4,0,0,0,.4-.4v-2.58l1.42-.82a.4.4,0,0,0,.15-.54.41.41,0,0,0-.55-.15l-1.62.94a.4.4,0,0,0-.2.34v2.81A.4.4,0,0,0,434.86,232.19Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.38 173.27 373.58 177.95 309.94 214.69 304.29 211.43 370.38 173.27"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cornice--inject-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "394.85 267.72 467.88 225.56 467.88 229.88 394.85 272.04 394.85 267.72",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "394.85 267.72 467.88 225.56 467.88 229.88 394.85 272.04 394.85 267.72",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "297.32 211.43 297.32 215.75 394.85 272.04 394.85 267.72 297.32 211.43",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "297.32 211.43 297.32 215.75 394.85 272.04 394.85 267.72 297.32 211.43",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "426.56 265.17 426.56 286.12 412.48 294.25 412.48 273.3 426.56 265.17",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.87 285 412.48 292.15 412.48 273.3 424.87 266.14 424.87 285",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.87 285 412.48 292.15 412.48 273.3 424.87 266.14 424.87 285",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.56 265.17 424.87 266.14 424.87 285 426.56 286.12 426.56 265.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.91 295.15 428.12 285.21 428.9 285.66 411.68 295.6 410.91 295.15",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.68 295.6 411.68 297.41 428.9 287.47 428.9 285.66 411.68 295.6",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.68 295.6 411.68 297.41 428.9 287.47 428.9 285.66 411.68 295.6",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.91 295.15 410.91 296.96 411.68 297.41 411.68 295.6 410.91 295.15",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.91 295.15 410.91 296.96 411.68 297.41 411.68 295.6 410.91 295.15",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.74 288.54 418.74 269.69 419.64 269.16 419.64 288.01 418.74 288.54",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "451.74 250.64 451.74 271.59 437.65 279.72 437.65 258.77 451.74 250.64",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.05 270.47 437.65 277.63 437.65 258.77 450.05 251.62 450.05 270.47",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.05 270.47 437.65 277.63 437.65 258.77 450.05 251.62 450.05 270.47",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.74 250.64 450.05 251.62 450.05 270.47 451.74 271.59 451.74 250.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.09 280.63 453.3 270.69 454.08 271.13 436.86 281.07 436.09 280.63",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.86 281.07 436.86 282.88 454.08 272.94 454.08 271.13 436.86 281.07",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.86 281.07 436.86 282.88 454.08 272.94 454.08 271.13 436.86 281.07",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.09 280.63 436.09 282.43 436.86 282.88 436.86 281.07 436.09 280.63",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.09 280.63 436.09 282.43 436.86 282.88 436.86 281.07 436.09 280.63",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.91 274.01 443.91 255.16 444.82 254.63 444.82 273.49 443.91 274.01",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "426.56 307.11 426.56 328.06 412.48 336.2 412.48 315.25 426.56 307.11",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.87 326.94 412.48 334.1 412.48 315.25 424.87 308.09 424.87 326.94",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.87 326.94 412.48 334.1 412.48 315.25 424.87 308.09 424.87 326.94",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.56 307.11 424.87 308.09 424.87 326.94 426.56 328.06 426.56 307.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.91 337.1 428.12 327.16 428.9 327.61 411.68 337.55 410.91 337.1",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.68 337.55 411.68 339.35 428.9 329.41 428.9 327.61 411.68 337.55",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.68 337.55 411.68 339.35 428.9 329.41 428.9 327.61 411.68 337.55",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.91 337.1 410.91 338.91 411.68 339.35 411.68 337.55 410.91 337.1",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.91 337.1 410.91 338.91 411.68 339.35 411.68 337.55 410.91 337.1",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.74 330.49 418.74 311.63 419.64 311.11 419.64 329.96 418.74 330.49",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "451.74 292.59 451.74 313.54 437.65 321.67 437.65 300.72 451.74 292.59",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.05 312.42 437.65 319.57 437.65 300.72 450.05 293.56 450.05 312.42",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.05 312.42 437.65 319.57 437.65 300.72 450.05 293.56 450.05 312.42",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.74 292.59 450.05 293.56 450.05 312.42 451.74 313.54 451.74 292.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.09 322.57 453.3 312.63 454.08 313.08 436.86 323.02 436.09 322.57",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.86 323.02 436.86 324.83 454.08 314.89 454.08 313.08 436.86 323.02",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.86 323.02 436.86 324.83 454.08 314.89 454.08 313.08 436.86 323.02",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.09 322.57 436.09 324.38 436.86 324.83 436.86 323.02 436.09 322.57",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.09 322.57 436.09 324.38 436.86 324.83 436.86 323.02 436.09 322.57",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.91 315.96 443.91 297.11 444.82 296.58 444.82 315.44 443.91 315.96",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "426.56 349.06 426.56 370.01 412.48 378.14 412.48 357.19 426.56 349.06",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.87 368.89 412.48 376.05 412.48 357.19 424.87 350.04 424.87 368.89",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.87 368.89 412.48 376.05 412.48 357.19 424.87 350.04 424.87 368.89",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.56 349.06 424.87 350.04 424.87 368.89 426.56 370.01 426.56 349.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.91 379.05 428.12 369.11 428.9 369.55 411.68 379.49 410.91 379.05",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.68 379.49 411.68 381.3 428.9 371.36 428.9 369.55 411.68 379.49",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.68 379.49 411.68 381.3 428.9 371.36 428.9 369.55 411.68 379.49",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.91 379.05 410.91 380.85 411.68 381.3 411.68 379.49 410.91 379.05",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.91 379.05 410.91 380.85 411.68 381.3 411.68 379.49 410.91 379.05",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.74 372.43 418.74 353.58 419.64 353.06 419.64 371.91 418.74 372.43",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "451.74 334.53 451.74 355.49 437.65 363.62 437.65 342.67 451.74 334.53",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.05 354.36 437.65 361.52 437.65 342.67 450.05 335.51 450.05 354.36",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.05 354.36 437.65 361.52 437.65 342.67 450.05 335.51 450.05 354.36",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.74 334.53 450.05 335.51 450.05 354.36 451.74 355.49 451.74 334.53",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.09 364.52 453.3 354.58 454.08 355.03 436.86 364.97 436.09 364.52",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.86 364.97 436.86 366.77 454.08 356.83 454.08 355.03 436.86 364.97",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.86 364.97 436.86 366.77 454.08 356.83 454.08 355.03 436.86 364.97",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.09 364.52 436.09 366.33 436.86 366.77 436.86 364.97 436.09 364.52",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.09 364.52 436.09 366.33 436.86 366.77 436.86 364.97 436.09 364.52",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.91 357.91 443.91 339.05 444.82 338.53 444.82 357.38 443.91 357.91",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--door--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "317.8 355.3 317.34 355.56 317.34 325.18 317.8 325.44 317.8 355.3",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.8 355.3 317.34 355.56 317.34 325.18 317.8 325.44 317.8 355.3",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.34 355.56 315.53 354.52 315.53 322.05 333.18 332.24 333.18 364.71 331.37 363.66 331.37 333.28 317.34 325.18 317.34 355.56",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.53 322.05 333.18 332.24 333.63 331.97 315.98 321.79 315.53 322.05",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.53 322.05 333.18 332.24 333.63 331.97 315.98 321.79 315.53 322.05",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.18 364.71 333.18 332.24 333.63 331.97 333.63 364.45 333.18 364.71",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "333.63 331.97 333.63 364.45 333.18 364.71 333.18 332.24",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.34 325.21 317.34 355.57 331.37 363.56 331.37 333.32 317.34 325.21",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.37 333.32 331.37 361.8 318.88 354.59 318.88 326.11 331.37 333.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,359.23l-7.78-4.49a.12.12,0,0,1-.05-.09,1.45,1.45,0,0,0-.6-1.16.12.12,0,0,1,0-.09V345a.11.11,0,0,1,0-.09.09.09,0,0,1,.1,0,.35.35,0,0,0,.33,0,.51.51,0,0,0,.17-.45.09.09,0,0,1,.05-.08.09.09,0,0,1,.1,0l7.79,4.49a.11.11,0,0,1,.05.09,1.45,1.45,0,0,0,.6,1.16.11.11,0,0,1,0,.09v8.42a.09.09,0,0,1,0,.08.09.09,0,0,1-.1,0,.35.35,0,0,0-.33,0c-.11.06-.17.22-.17.44a.11.11,0,0,1-.05.09H329Zm.61-.74v-8.21a1.68,1.68,0,0,1-.66-1.24l-7.59-4.39a.59.59,0,0,1-.26.45.45.45,0,0,1-.38,0v8.21a1.66,1.66,0,0,1,.65,1.25l7.6,4.38a.59.59,0,0,1,.26-.45.42.42,0,0,1,.22,0A.47.47,0,0,1,329.57,358.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.88 354.59 317.34 355.57 331.37 363.67 331.37 361.8 318.88 354.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.19 329.33 329.57 334.17 329.58 347.45 321.19 342.6 321.19 329.33",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.19 329.33 329.57 334.17 329.58 347.45 321.19 342.6 321.19 329.33",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.88 345.31 325.36 345.61 329.58 348.05 329.58 347.45 325.88 345.31",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.19 342.6 321.19 329.33 320.68 329.03 320.68 342.9 321.19 342.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.19 342.6 320.68 342.9 324.85 345.32 324.85 344.72 321.19 342.6",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.36 345.61 324.85 345.32 324.85 331.44 325.36 331.74 325.36 345.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.36 345.61 325.88 345.31 325.88 332.04 325.36 331.74 325.36 345.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.37 337.51 325.88 337.22 329.58 339.36 329.58 339.95 325.37 337.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.37 337.51 325.37 338.11 329.58 340.54 329.58 339.95 325.37 337.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.68 334.8 321.19 334.51 324.85 336.62 324.85 337.21 320.68 334.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.68 334.8 320.68 335.4 324.85 337.81 324.85 337.21 320.68 334.8",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plan--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plan--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--architectural-plan--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.38,31.65l-1.76,1,0,125.4,97.6,56.35,1.77-1V88Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.38 31.65 370.62 32.67 468.21 89.02 469.98 88 372.38 31.65",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.98 88 468.21 89.02 468.2 214.42 469.96 213.4 469.98 88",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.6 158.07 370.62 32.67 468.21 89.02 468.2 214.42 370.6 158.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.12,33.54l96.59,55.77V213.54l-96.59-55.76V33.54m-.5-.87,0,125.4,97.6,56.35,0-125.4-97.6-56.35Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.85,40.25l-.38-.22V155.15L464,206.83l.38.22V91.93Zm80.78,161.1-13.87-8v-2.06l13.87,8Zm0-2.74-13.87-8v-2.06l13.87,8Zm0-2.74-13.87-8V185.8l13.87,8Zm0-2.74-13.87-8v-2.07l13.87,8Zm8.21,13-7.71-4.45V191.36l7.71,4.45Zm0-11-22.08-12.75v-2.07l22.08,12.75Zm0-2.74-22.08-12.75v-2.06l22.08,12.75Zm0-2.74-22.58-13v16.43L375,154.77,375,41l88.88,51.31Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.85,40.25l-.38-.22V155.15L464,206.83l.38.22V91.93Zm80.78,161.1-13.87-8v-2.06l13.87,8Zm0-2.74-13.87-8v-2.06l13.87,8Zm0-2.74-13.87-8V185.8l13.87,8Zm0-2.74-13.87-8v-2.07l13.87,8Zm8.21,13-7.71-4.45V191.36l7.71,4.45Zm0-11-22.08-12.75v-2.07l22.08,12.75Zm0-2.74-22.08-12.75v-2.06l22.08,12.75Zm0-2.74-22.58-13v16.43L375,154.77,375,41l88.88,51.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.52,159.16l-2.12-4a2.15,2.15,0,0,0-1.28-1.18.73.73,0,0,0-.66.13h0l-2.21,1.66c-.54.41-.55,1.51,0,2.5l2.12,4.05.59,1.15a.15.15,0,0,0,.09.06h0l.07,0,4-3a.13.13,0,0,0,0-.16Zm-6.08-1c-.45-.86-.46-1.86,0-2.19l2.2-1.66a.5.5,0,0,1,.45-.09,2,2,0,0,1,1.12,1.06l2.07,4-1.74,1.31-2,1.53Zm2.65,5.06-.48-.92,1.73-1.31,2-1.53.48.92ZM412.46,77.5a.12.12,0,0,0-.09.15l4.22,14.9a.13.13,0,0,0,.13.09h0a.13.13,0,0,0,.09-.16l-4.23-14.89A.11.11,0,0,0,412.46,77.5Zm37.18,58.82a2.83,2.83,0,0,0,0,.3,5.17,5.17,0,0,0,.16,1.22,3,3,0,0,0-.9,1,.11.11,0,0,0,0,.13.13.13,0,0,0,.13.05,4,4,0,0,1,1.18,0,5.63,5.63,0,0,0,1.15,1.67,11.62,11.62,0,0,0,.17,2.29.14.14,0,0,0,.13.1.13.13,0,0,0,.12-.11,8.25,8.25,0,0,1,.44-1.65,2,2,0,0,0,.84.23,1.29,1.29,0,0,0,.48-.1,11.66,11.66,0,0,1,1,2.07.14.14,0,0,0,.12.09h0a.12.12,0,0,0,.11-.12,8.45,8.45,0,0,0-.58-2.63,2.7,2.7,0,0,0,.36-1.22,4.66,4.66,0,0,1,.86.71.12.12,0,0,0,.16,0,.14.14,0,0,0,.05-.16,7.19,7.19,0,0,0-1.16-1.79,6.75,6.75,0,0,0-.49-1.5,3.79,3.79,0,0,0,.6-1.71.13.13,0,0,0-.23-.09,2.71,2.71,0,0,1-1,.7,4.42,4.42,0,0,0-1.15-1.07,2.45,2.45,0,0,0-.54-.22,9,9,0,0,0-1.46-2.11.11.11,0,0,0-.16,0,.14.14,0,0,0-.05.16,18.06,18.06,0,0,1,.72,2l-.19.07a1.6,1.6,0,0,0-.6.7,3.1,3.1,0,0,0-1.63-.2.13.13,0,0,0-.1.1.12.12,0,0,0,.06.13A11,11,0,0,1,449.64,136.32Zm5.45,3.36a3.52,3.52,0,0,0-.5-.35c0-.15,0-.3,0-.45A6.52,6.52,0,0,1,455.09,139.68Zm-3.75.66a5.85,5.85,0,0,1-.86-1.28,4,4,0,0,1,.93.26C451.39,139.49,451.36,139.86,451.34,140.34Zm.31,1.87c0-.45-.06-.89-.06-1.29a4.33,4.33,0,0,0,.37.27A9.77,9.77,0,0,0,451.65,142.21Zm.63-1.14a6.06,6.06,0,0,1,.44-.87c.13.19.38.57.66,1A1.39,1.39,0,0,1,452.28,141.07Zm2.17,1.55c-.21-.44-.46-.89-.7-1.29a1.49,1.49,0,0,0,.28-.23A10.41,10.41,0,0,1,454.45,142.62Zm-.35-2.08c-.23-.62-.46-1.14-.6-1.42a3.8,3.8,0,0,1,.83.34A2.65,2.65,0,0,1,454.1,140.54Zm.06-2.48a3.36,3.36,0,0,0-.68-.49c.09-.09.21-.25.35-.43A6.32,6.32,0,0,1,454.16,138.06Zm.12-2.53a3.87,3.87,0,0,1-.42,1.09,5.44,5.44,0,0,0-.39-.62A4.79,4.79,0,0,0,454.28,135.53Zm-2.24-.59a3.86,3.86,0,0,1,1,.95c-.29.12-.55.21-.69.26-.21-.5-.4-.92-.59-1.31Zm-1.55-1.78a10.58,10.58,0,0,1,.82,1.27,1.67,1.67,0,0,0-.39,0C450.79,134,450.64,133.57,450.49,133.16Zm.13,1.66a.75.75,0,0,1,.13-.06c.15.47.27.9.35,1.18a5.29,5.29,0,0,0-1-.54A1.31,1.31,0,0,1,450.62,134.82Zm-.59.81a6.24,6.24,0,0,1,1.21.72.12.12,0,0,0,.15,0,.12.12,0,0,0,.05-.14c0-.05-.19-.72-.44-1.52l.16,0a1.54,1.54,0,0,1,.3,0c.24.48.47,1,.74,1.63a.11.11,0,0,0,.15.07s.43-.13.89-.32a5.4,5.4,0,0,1,.46.77,3.11,3.11,0,0,1-.52.65.14.14,0,0,0,0,.12.12.12,0,0,0,.08.09,3.37,3.37,0,0,1,1,.79c0,.22.06.44.07.65a2.87,2.87,0,0,0-1-.35.1.1,0,0,0-.11.05.12.12,0,0,0,0,.13s.4.82.76,1.82a1.26,1.26,0,0,1-.31.3c-.42-.68-.77-1.18-.8-1.22a.13.13,0,0,0-.11-.05.14.14,0,0,0-.1.05,5.39,5.39,0,0,0-.55,1,3.09,3.09,0,0,1-.47-.36c0-.76.08-1.31.08-1.32a.12.12,0,0,0-.07-.13,4.24,4.24,0,0,0-1.24-.35,6.21,6.21,0,0,1-.3-.82,2,2,0,0,1,1.09-.27.15.15,0,0,0,.13-.06.14.14,0,0,0,0-.15,14.25,14.25,0,0,0-1.36-1.28A3,3,0,0,1,450,135.63Zm-.15.88a13.23,13.23,0,0,1,1,.93,2.33,2.33,0,0,0-.88.26,5.06,5.06,0,0,1-.13-1.08S449.88,136.55,449.88,136.51Zm.19,2.24a4.75,4.75,0,0,0-.84,0,2.84,2.84,0,0,1,.62-.66A5,5,0,0,0,450.07,138.75Zm-1.38-3.43a3.12,3.12,0,0,1,1.1.22,3.23,3.23,0,0,0-.12.47,11.42,11.42,0,0,0-1-.69ZM410.19,73a.14.14,0,0,0,.11.06.11.11,0,0,0,.07,0,.12.12,0,0,0,0-.17l-3.46-5a.13.13,0,0,0-.18,0,.12.12,0,0,0,0,.17Zm-18.87,52.52h0l15.52,9H407a.14.14,0,0,0,.06-.11V109.87a.11.11,0,0,0-.06-.11L382.64,95.7a.15.15,0,0,0-.13,0,.13.13,0,0,0-.06.11v24.52a.11.11,0,0,0,.06.11Zm.2-24.4,15.27,8.82v24.23l-15.27-8.82Zm-1.21-.7.6.35.36.21V125.2l-.7-.4-.26-.15ZM382.7,96l7.36,4.25v24.23l-7.36-4.25ZM387,111.15l-2-1.15a1,1,0,0,0-1.06-.07,1.38,1.38,0,0,0-.55,1.26v6.25a3.54,3.54,0,0,0,1.48,2.83l2,1.15a1.34,1.34,0,0,0,.63.19.89.89,0,0,0,.43-.11,1.41,1.41,0,0,0,.55-1.26V114A3.55,3.55,0,0,0,387,111.15Zm1.23,9.09a1.14,1.14,0,0,1-.43,1,.81.81,0,0,1-.8-.08l-2-1.15a3.26,3.26,0,0,1-1.36-2.61v-6.25a1.12,1.12,0,0,1,.43-1,.52.52,0,0,1,.3-.08,1.05,1.05,0,0,1,.5.15l2,1.15a3.28,3.28,0,0,1,1.36,2.61ZM387,99.86l-2-1.15a1,1,0,0,0-1.06-.07,1.38,1.38,0,0,0-.55,1.26v6.26a3.53,3.53,0,0,0,1.48,2.82l2,1.15a1.23,1.23,0,0,0,.63.19.89.89,0,0,0,.43-.11,1.41,1.41,0,0,0,.55-1.26v-6.26A3.55,3.55,0,0,0,387,99.86Zm1.23,9.09a1.14,1.14,0,0,1-.43,1,.79.79,0,0,1-.8-.08l-2-1.15a3.26,3.26,0,0,1-1.36-2.6V99.9a1.12,1.12,0,0,1,.43-1,.79.79,0,0,1,.8.07l2,1.15a3.28,3.28,0,0,1,1.36,2.61Zm28.41-35.49-3.47,1.05a.13.13,0,0,0-.08.16.14.14,0,0,0,.12.09h0l3.46-1a.14.14,0,0,0,.09-.16A.13.13,0,0,0,416.68,73.46Zm41.87,20.25L379.39,48a.11.11,0,0,0-.13,0,.11.11,0,0,0-.06.11v79.06a.11.11,0,0,0,.06.1l6.93,4v8a.12.12,0,0,0,.07.11l26.49,15.3h.12a.15.15,0,0,0,.07-.11v-7.91l11.93,6.89v8.05a.11.11,0,0,0,.06.11L451.42,177h.13a.14.14,0,0,0,.06-.11V169l6.81,3.93h.13a.17.17,0,0,0,.06-.11v-79A.15.15,0,0,0,458.55,93.71Zm-45.87,60.66-26.24-15.15v-7.84l.83.48h0L411.73,146h0l.95.55Zm-30.5-62.78.07,0,.06,0a.11.11,0,0,0,.06-.11V74.73a.14.14,0,0,0-.06-.11l-.67-.39V52.47L405.12,66V86.78l-11-6.34a.15.15,0,0,0-.13,0,.11.11,0,0,0-.06.11v1c0,.26,0,.51,0,.76,0,0,0,0,0,0v.22a.11.11,0,0,0,.06.11l12.39,7.16v.91a.15.15,0,0,0,.07.11L419,98.11h.12a.14.14,0,0,0,.07-.11v-.76l.9.52a.15.15,0,0,0,.13,0,.13.13,0,0,0,.06-.11V74.83l18.24,10.54h0l.4.23,7.27,4.2V103h0v23.08l-7.48-4.31V102a.11.11,0,0,0-.06-.1l-2.22-1.34a.15.15,0,0,0-.13,0,.11.11,0,0,0-.06.11v22.79a.14.14,0,0,0,.06.11L456.17,135v33.4l-5.64-3.26h0l-24.45-14.12h0l-5.77-3.32V114.4a.13.13,0,0,0-.06-.11l-2.57-1.6s0,0,0,0,0,0,0,0l-5.77-3.33a.11.11,0,0,0-.13,0,.11.11,0,0,0-.06.1v17.12a.13.13,0,0,0,.06.11l.72.41.06,0,.07,0a.11.11,0,0,0,.06-.11V111.16l4.87,2.81h0V146.1l-3.75-2.17V128a.12.12,0,0,0-.07-.11l-.72-.42a.13.13,0,0,0-.12,0,.14.14,0,0,0-.07.11v15.79l-.91-.53h0L387.4,128.72h0l-5.76-3.32V91.28Zm-.54-.61V74.53l.48.28V91.24Zm25-1L419,97.09v.69l-12.31-7.11v-.12s0,0,0,0C406.66,90.34,406.66,90.16,406.66,90Zm39.81,32.91v-3l9.7,5.6v3Zm9.7,5.89v3l-9.7-5.59v-3Zm-9.7-9.22v-3l9.7,5.6v3Zm0-3.33v-3l9.7,5.6v3Zm0-3.33v-3l9.7,5.6v3Zm0-3.33v-3l9.7,5.59v3Zm0-3.33v-3l9.7,5.59v3Zm.1-3.27,9.6-7.25v12.79Zm-.1-.24V89.94l.28.17,9.31,5.38Zm9.7,29.38v2.63l-19.65-11.35V100.9l2,1.19v19.74a.13.13,0,0,0,.06.11l7.73,4.46h0Zm-30,20.92v-.67l24.2,14V167Zm24.2,14.27V168L444,164.31,426.14,154v-.68Zm-24.2-15.23v-.69L429,153l21.38,12.35V166ZM411.9,110.45v-.82l5.52,3.19v.82l-4.86-2.81h0Zm.47.56v15.72l-.47-.27V110.74h0Zm1.11,17.06v15.71l-.15-.08-.31-.19V127.8Zm-26,2.63V130l24.21,14v.68ZM411.67,145v.68l-24.21-14V131Zm-24.21-15.23v-.69l0,0L411.67,143v.68Zm37.6,23.64-12.19-7h0l-.95-.55v-2.63l5.63,3.26a.15.15,0,0,0,.13,0,.14.14,0,0,0,.06-.11V113l.58.36a.13.13,0,0,0,.06.09c.21.14.43.27.65.4h.08l.95.59V147.8a.11.11,0,0,0,.06.11l5.77,3.33v2.62l-.83-.48Zm26.3,23.32-26.24-15.15v-7.84l.83.48h0l14.64,8.45,10.77,6.22Zm7-4.09-7.77-4.48V165.5l5.64,3.26h.13a.14.14,0,0,0,.06-.11v-7.51l.54.31.36.21,1,.6Zm-1.94-11.76V139.62l.48.28v21.22Zm.73.42V140l.24.14.23.13v21.23l-.23-.13Zm1.21.7-.48-.28V140.46l.48.28Zm0-21.52-.55-.32-.36-.21-1-.59V132h0v-7.11l.9.52.37.21h0l.67.39Zm-1.94-31.72V103.4l.48.27V124.9l-.48-.27v-15.9Zm.73,16.32V103.82l.24.14.23.13v21.23l-.45-.26Zm1.21.69-.48-.27V104.24l.48.28Zm0-21.52-.55-.31-.36-.21-1-.59V95.47a0,0,0,0,0,0,0,.07.07,0,0,0,0-.06s0,0,0,0a0,0,0,0,1,0,0l-9.95-5.75L439,85.31,420.25,74.5a.15.15,0,0,0-.13,0,.11.11,0,0,0-.06.11V97.43l-.91-.52h0l-12.56-7.26h0L394.2,82.5V80.77l11,6.34h0l.81.47h0l11.55,6.67a.15.15,0,0,0,.13,0,.11.11,0,0,0,.06-.11v-21a.11.11,0,0,0-.06-.11L381.57,52.14a.13.13,0,0,0-.12,0,.11.11,0,0,0-.06.11v73.22a.11.11,0,0,0,.06.11l5.76,3.33v2.62l-.83-.47h0l-6.93-4V48.29l78.91,45.6Zm-53-17.29V66.2l.56.33V87.25Zm.81.47V66.66l11.3,6.53V93.92ZM411.84,74a.59.59,0,0,0-.6,0,.77.77,0,0,0-.31.7,1.83,1.83,0,0,0,.78,1.48.69.69,0,0,0,.35.1.54.54,0,0,0,.25-.06.76.76,0,0,0,.31-.69A1.85,1.85,0,0,0,411.84,74Zm.34,2a.37.37,0,0,1-.34,0,1.58,1.58,0,0,1-.66-1.26.53.53,0,0,1,.19-.48.27.27,0,0,1,.12,0,.52.52,0,0,1,.22.07,1.62,1.62,0,0,1,.66,1.27A.52.52,0,0,1,412.18,76Zm-1.24.77-4.22,10a.13.13,0,0,0,.06.17h.05a.13.13,0,0,0,.12-.08l4.22-10a.12.12,0,0,0-.07-.17A.14.14,0,0,0,410.94,76.74ZM392.4,66.66l.06,0,.06,0a.12.12,0,0,0,.07-.11V60.27a.12.12,0,0,0-.07-.11l-9.77-5.64a.13.13,0,0,0-.12,0,.12.12,0,0,0-.07.11v6.28a.12.12,0,0,0,.07.11Zm-9.58-11.81,9.51,5.49v6l-9.51-5.49Zm16.11,39.49a.88.88,0,0,0-.88-.06,1.15,1.15,0,0,0-.45,1V100a.14.14,0,0,0,.06.11l5.16,3,.06,0,.06,0A.12.12,0,0,0,403,103V98.29A2.86,2.86,0,0,0,401.8,96Zm3.82,8.46-4.9-2.84v-.75l4.9,2.84Zm0-4.51v3.46l-4.9-2.83v-3.6a.91.91,0,0,1,.33-.82.59.59,0,0,1,.62.06l2.87,1.66A2.58,2.58,0,0,1,402.75,98.29Zm21.18-1.12.07,0,.06,0a.11.11,0,0,0,.06-.11V80.84a.11.11,0,0,0-.06-.11l-3-1.72a.11.11,0,0,0-.13,0,.11.11,0,0,0-.06.1V95.34a.14.14,0,0,0,.06.11Zm-2.79-17.84,2.73,1.58V96.84l-2.73-1.58Zm-23.28-5a1.67,1.67,0,0,0,.86.26,1.14,1.14,0,0,0,.58-.15,1.9,1.9,0,0,0,.76-1.74,5,5,0,0,0-2.07-4,1.42,1.42,0,0,0-1.45-.1,1.9,1.9,0,0,0-.76,1.73A5,5,0,0,0,397.86,74.37Zm-1.19-5.48a1,1,0,0,1,.45-.11,1.49,1.49,0,0,1,.74.22,4.68,4.68,0,0,1,1.95,3.74,1.69,1.69,0,0,1-.63,1.52,1.18,1.18,0,0,1-1.19-.1,4.71,4.71,0,0,1-2-3.75A1.68,1.68,0,0,1,396.67,68.89Zm45.47,82.56a5,5,0,0,0,2.5.75,3.28,3.28,0,0,0,1.64-.42c1.4-.81,2.19-2.66,2.19-5.09,0-4.56-2.78-9.87-6.21-11.85a4.09,4.09,0,0,0-4.15-.33c-1.39.81-2.18,2.66-2.18,5.09C435.93,144.16,438.71,149.47,442.14,151.45Zm-3.9-16.72a3,3,0,0,1,1.52-.39,4.82,4.82,0,0,1,2.38.72c3.35,1.93,6.08,7.15,6.08,11.63,0,2.34-.75,4.11-2.06,4.87a3.85,3.85,0,0,1-3.9-.33c-3.35-1.93-6.08-7.16-6.08-11.63C436.18,137.26,436.93,135.49,438.24,134.73Zm-16.57-16.39a.11.11,0,0,0-.06.11v26.49a.13.13,0,0,0,.06.11l2.58,1.49,6.79,3.92.07,0,.06,0a.11.11,0,0,0,.06-.11V123.86a.11.11,0,0,0-.06-.11l-6.8-3.92-2.57-1.49A.11.11,0,0,0,421.67,118.34Zm2.77,1.81,6.54,3.78v1.71l-6.54-3.78Zm0,2,6.54,3.78v7.21l-6.54-3.78Zm0,7.5,6.54,3.78v7.21l-6.54-3.78Zm0,7.5,6.54,3.78v7.2l-6.54-3.78Zm0,7.5,6.54,3.77v1.71l-6.54-3.78Zm-2.58-26,2.32,1.34v26.2l-2.32-1.34ZM394.81,65.4a.15.15,0,0,0-.13,0,.11.11,0,0,0-.06.11v4.23a7.74,7.74,0,0,0,3.24,6.18,2.64,2.64,0,0,0,1.33.4,1.74,1.74,0,0,0,.87-.23,3,3,0,0,0,1.16-2.68V69.18a.11.11,0,0,0-.06-.11Zm6.16,8a2.73,2.73,0,0,1-1,2.46A1.91,1.91,0,0,1,398,75.7a7.47,7.47,0,0,1-3.12-6v-4l6.1,3.52Zm4.1,23.39.07,0,.06,0a.11.11,0,0,0,.06-.11V90.31a.14.14,0,0,0-.06-.11l-9.67-5.58a.15.15,0,0,0-.13,0,.11.11,0,0,0-.06.11v6.38a.13.13,0,0,0,.06.11ZM395.59,85,405,90.39v6.08L395.59,91Zm6.12-16.5.06,0,.07,0a.11.11,0,0,0,.06-.11V65.65a.11.11,0,0,0-.06-.11l-7.7-4.45a.15.15,0,0,0-.13,0,.13.13,0,0,0-.06.11v2.7A.14.14,0,0,0,394,64Zm-7.51-7,7.45,4.3v2.4l-7.45-4.3Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tools--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screwdriver--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--screwdriver--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.59,412.37l-4.31,7.47-14.56-8.4a2.09,2.09,0,0,1-1-2,6.73,6.73,0,0,1,3.05-5.28,2.14,2.14,0,0,1,2.16-.22h0Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.46,413.92h0c.07,1.13,1.68,1.38,1.68,1.38l-3.05,5.29s-1-1.26-2-.76h0c-1.5.65-2.67-.16-2.67-2a6.79,6.79,0,0,1,3.05-5.29C362,411.69,363.27,412.29,363.46,413.92Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.46,413.92h0c.07,1.13,1.68,1.38,1.68,1.38l-3.05,5.29s-1-1.26-2-.76h0c-1.5.65-2.67-.16-2.67-2a6.79,6.79,0,0,1,3.05-5.29C362,411.69,363.27,412.29,363.46,413.92Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.41,415.07a3.42,3.42,0,0,0,.73.23l-3.05,5.29a3.73,3.73,0,0,0-.57-.52A6.85,6.85,0,0,1,364.41,415.07Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.32,415.67l-.26.45a3,3,0,0,1,.13.94,6.76,6.76,0,0,1-3.05,5.29,3.08,3.08,0,0,1-.89.36l-.25.44-1-.58h0a2.16,2.16,0,0,1-.89-2,6.73,6.73,0,0,1,3.05-5.29,2.14,2.14,0,0,1,2.16-.21h0Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.1,421.18a6.74,6.74,0,0,1,3.06-5.29c1.68-1,3-.19,3,1.76a6.76,6.76,0,0,1-3,5.29C364.47,423.91,363.1,423.12,363.1,421.18Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.1,421.18a6.74,6.74,0,0,1,3.06-5.29c1.68-1,3-.19,3,1.76a6.76,6.76,0,0,1-3,5.29C364.47,423.91,363.1,423.12,363.1,421.18Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.35,422a6,6,0,0,1-.76.68l-.72-2,.87-.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.23,407.33h0a.85.85,0,0,0,.31,1.15l10.4,6a.84.84,0,0,0,1.15-.3h0a.84.84,0,0,0-.31-1.15l-10.4-6A.85.85,0,0,0,345.23,407.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.11,405.09h0a.5.5,0,0,0,0,.87l10.6,6.11a1.15,1.15,0,0,0,1.22-.13h0a.49.49,0,0,0,0-.86L348.33,405A1.16,1.16,0,0,0,347.11,405.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.23,410.07h0a.5.5,0,0,1,.77-.4l10.59,6.12a1.16,1.16,0,0,1,.5,1.13h0a.5.5,0,0,1-.77.4l-10.59-6.12A1.16,1.16,0,0,1,344.23,410.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.93,433.51v2l-5.09-1.66a7.93,7.93,0,0,0-2-2.46l-19.34-11.16-.6-1.69.6-.35,19.34,11.17a2,2,0,0,0,2-.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.34,433.85v2l-5.09-1.65a7.75,7.75,0,0,0-2-2.46l-19.34-11.17v-2l19.34,11.16a2,2,0,0,0,2-.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.34 435.89 392.93 435.55 392.93 433.51 392.34 433.85 392.34 435.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.93 433.51 392.34 433.85 387.25 429.63 387.84 429.29 392.93 433.51",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hammer--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--hammer--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311,408.65a6.47,6.47,0,0,0-2.9,5.09,2,2,0,0,0,.89,1.89l19.6,11.16,4.09-7.19-19.59-11.15A2,2,0,0,0,311,408.65Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.61,418.71a7.47,7.47,0,0,0-3.33,5.86,2.36,2.36,0,0,0,1,2.18l1.24.7,4.7-8.27-1.22-.7A2.37,2.37,0,0,0,329.61,418.71Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.61,418.71a7.47,7.47,0,0,0-3.33,5.86,2.36,2.36,0,0,0,1,2.18l1.24.7,4.7-8.27-1.22-.7A2.37,2.37,0,0,0,329.61,418.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.54,425.28c0,2.15,1.53,3,3.38,1.93a7.45,7.45,0,0,0,3.33-5.86c0-2.14-1.52-3-3.38-1.92A7.46,7.46,0,0,0,327.54,425.28Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.9,421.62a3.26,3.26,0,0,0-1.46,2.56,1,1,0,0,0,.45,1L363.06,444l2.05-3.62L332,421.52A1,1,0,0,0,330.9,421.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.73,442.84l-.67,1.18-33.17-18.88a1,1,0,0,1-.45-1,2.71,2.71,0,0,1,.13-.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.32,442.52a4.49,4.49,0,0,1-.5,2.22,8.54,8.54,0,0,1-3.6,3.89c-.27.17-.72.43-1,.59l-3.7,2.17a2.68,2.68,0,0,1-1.08.3h-.73a2.43,2.43,0,0,0-1.08.3l-2,.95a.82.82,0,0,1-.92-.11L360.88,451a.45.45,0,0,1-.15-.32c0-.14,0-5.29,0-5.37a.41.41,0,0,1,.22-.46l.88-.51a1.15,1.15,0,0,0,.5-.88v-1a1.1,1.1,0,0,1,.5-.88l4.64-2.72a1.27,1.27,0,0,1,1-.05,8.5,8.5,0,0,0,3.86.86,5.17,5.17,0,0,0,4.08-5,4,4,0,0,1,.88,2.46C377.3,437.8,377.26,441.08,377.32,442.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.93,444.89l.88-.51a1.15,1.15,0,0,0,.5-.88v-1a1.1,1.1,0,0,1,.5-.88l4.64-2.72a1.27,1.27,0,0,1,1-.05,8.5,8.5,0,0,0,3.86.86,5.17,5.17,0,0,0,4.08-5,4.13,4.13,0,0,1,.38,4.56,8.54,8.54,0,0,1-3.6,3.89c-.27.17-.72.43-1,.59l-3.7,2.17a2.56,2.56,0,0,1-1.08.29h-.73a2.4,2.4,0,0,0-1.08.3l-2,.95a.84.84,0,0,1-.93-.11l-1.8-1.79A.42.42,0,0,1,360.93,444.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.06,445a7.89,7.89,0,0,1,3.61,6.16,2.47,2.47,0,0,1-1.06,2.32l-3.53,2.07-5.09-8.7,3.52-2.06A2.47,2.47,0,0,1,362.06,445Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.11,453.28c0,2.28-1.58,3.21-3.56,2.08a7.88,7.88,0,0,1-3.6-6.16c0-2.27,1.58-3.21,3.55-2.08A7.88,7.88,0,0,1,362.11,453.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.77,445.78a2.08,2.08,0,0,0-.93,1.63.67.67,0,0,0,.29.61l.93.53,1.31-2.3-.93-.53A.66.66,0,0,0,371.77,445.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.78,448c0,.59.43.83.94.53a2.07,2.07,0,0,0,.93-1.63c0-.59-.43-.83-.94-.53A2.07,2.07,0,0,0,371.78,448Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.28,439.69a10,10,0,0,1-2,4,5.42,5.42,0,0,0,2.05-2.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.36,411.63h0a.77.77,0,0,0,.29,1.05l14.79,8.42a.77.77,0,0,0,1.06-.28h0a.78.78,0,0,0-.29-1.06l-14.8-8.42A.77.77,0,0,0,310.36,411.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.07,409.57h0a.45.45,0,0,0,0,.79l15,8.52a1,1,0,0,0,1.13-.13h0a.45.45,0,0,0,0-.79l-15-8.52A1,1,0,0,0,312.07,409.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.46,414.15h0a.45.45,0,0,1,.7-.37l15,8.53a1,1,0,0,1,.47,1h0a.45.45,0,0,1-.7.37l-15-8.53A1,1,0,0,1,309.46,414.15Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trowel--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M464.66,414.93l-3.45-2a1.67,1.67,0,0,0-1.51,0l-14.06,8.12a.46.46,0,0,0,0,.87l.59.34-7.91,4.57-9.72-5.62a2.67,2.67,0,0,0-1.33-.35,2.73,2.73,0,0,0-2.27,1.19l-11,16.47a1.51,1.51,0,0,0-.26,1.62,1.2,1.2,0,0,0,1.16.6,3.09,3.09,0,0,0,.58-.06L445.83,434c1.05-.23,1.29-.79,1.34-1.1s0-.91-.94-1.45l-5.77-3.33,7.9-4.57.72.42a1.67,1.67,0,0,0,1.51,0l14.07-8.12A.46.46,0,0,0,464.66,414.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trowel--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462,405.36a1.53,1.53,0,0,1-.67,1.43l-12,6.82a3.13,3.13,0,1,1-3.09-5.43l12-6.81a1.54,1.54,0,0,1,1.58.15A4.88,4.88,0,0,1,462,405.36Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,405.36a4.89,4.89,0,0,0-1.39-3.2c.9,1.28,1,2.51-1.67,4.06s-8.65,5-9.81,5.63-3.36,1.36-4.51-.7a3,3,0,0,0,.38,1.34,3.18,3.18,0,0,0,4.35,1.12l12-6.82A1.53,1.53,0,0,0,462,405.36Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.62,410.89a2.39,2.39,0,0,1,1.06,1.86.74.74,0,0,1-.33.69l-.9.51L444,411.32l.9-.5A.74.74,0,0,1,445.62,410.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.77,413.26c0,.68-.49.95-1.07.61a2.37,2.37,0,0,1-1.06-1.86c0-.68.48-.95,1.07-.61A2.39,2.39,0,0,1,445.77,413.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.39,413a1.53,1.53,0,0,0-.68-1.2.46.46,0,0,0-.51,0l-2.2,1.27a6.51,6.51,0,0,0-3.25,5.63v1.89a6,6,0,0,1-3,5.17l-1.78,1,1,1.68,1.78-1a7.93,7.93,0,0,0,3.95-6.84v-1.89a4.56,4.56,0,0,1,2.28-3.95l2.21-1.28h0A.49.49,0,0,0,445.39,413Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.91,431.21,428.28,421a2.09,2.09,0,0,0-2.75.64l-11,16.46a1.46,1.46,0,0,0-.28.75c0,.1,0,.49,0,.58,0,.42.39.61,1.09.46l30.32-6.73c.56-.13.84-.37.84-.64V432C446.54,431.72,446.34,431.45,445.91,431.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.28,421l17.63,10.18c.93.53.83,1.15-.21,1.38l-30.32,6.74c-1,.23-1.41-.31-.82-1.2l11-16.46A2.09,2.09,0,0,1,428.28,421Z",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tool-box--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tool-box--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M100.72,461.58,64.53,440.69c-1.31-.76-1.31-2,0-2.75l58.52-33.78a5.25,5.25,0,0,1,4.76,0L164,425.05c1.31.76,1.31,2,0,2.75l-58.51,33.78A5.25,5.25,0,0,1,100.72,461.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tool-box--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "103.1 458.1 103.1 428.01 65.88 406.52 69.6 438.76 103.1 458.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.1 458.1 158.93 425.86 162.65 393.63 103.1 428.01 103.1 458.1",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.55,400.08a1.68,1.68,0,0,1,1-1.38l58.52-33.78a5.25,5.25,0,0,1,4.76,0L164,385.81a1.68,1.68,0,0,1,1,1.37c0,.5,0,8.1,0,8.6a1.68,1.68,0,0,1-1,1.38l-58.51,33.78a5.25,5.25,0,0,1-4.76,0L64.53,410.05a1.67,1.67,0,0,1-1-1.37Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.53,398.7l38.57-22.26v55.07a4.82,4.82,0,0,1-2.38-.57L64.53,410.05a1.67,1.67,0,0,1-1-1.37v-8.6A1.68,1.68,0,0,1,64.53,398.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.1,376.44l20-11.52a5.25,5.25,0,0,1,4.76,0L164,385.81a1.68,1.68,0,0,1,1,1.37c0,.5,0,8.1,0,8.6a1.68,1.68,0,0,1-1,1.38l-58.51,33.78a4.87,4.87,0,0,1-2.38.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.72,422.34,64.53,401.45c-1.31-.76-1.31-2,0-2.75l58.52-33.78a5.25,5.25,0,0,1,4.76,0L164,385.81c1.31.76,1.31,2,0,2.75l-58.51,33.78A5.25,5.25,0,0,1,100.72,422.34Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.34,388.26c1,.59,1,1.58-.12,2.22L112.52,414a4.2,4.2,0,0,1-3.84.07c-1-.59-1-1.58.12-2.22l40.7-23.49A4.23,4.23,0,0,1,153.34,388.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.52,414a4.2,4.2,0,0,1-3.84.07,1,1,0,0,1-.2-.14,2.57,2.57,0,0,1,.32-.22l40.7-23.5a4.26,4.26,0,0,1,3.84-.07,1,1,0,0,1,.2.14,2,2,0,0,1-.32.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.57,371.06c1,.6,1,1.59-.12,2.22l-40.7,23.5a4.25,4.25,0,0,1-3.85.07c-1-.59-1-1.59.13-2.22l40.69-23.49A4.25,4.25,0,0,1,123.57,371.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.75,396.78a4.25,4.25,0,0,1-3.85.07l-.2-.14a2.75,2.75,0,0,1,.33-.23L119.72,373a4.22,4.22,0,0,1,3.85-.07,1.43,1.43,0,0,1,.2.14,2.57,2.57,0,0,1-.32.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.34,399c-1,.59-1,1.58.12,2.21l14.65,8.45a4.25,4.25,0,0,0,3.85.08c1-.6,1-1.59-.12-2.22l-14.65-8.45A4.22,4.22,0,0,0,86.34,399Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.11,409.67a4.25,4.25,0,0,0,3.85.08l.2-.15a2.57,2.57,0,0,0-.32-.22l-14.65-8.45a4.22,4.22,0,0,0-3.85-.07,1.43,1.43,0,0,0-.2.14,2.57,2.57,0,0,0,.32.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,403.3c-1,.59-1,1.59.13,2.22L93.68,414a4.26,4.26,0,0,0,3.84.07c1-.59,1-1.59-.12-2.22l-14.65-8.45A4.28,4.28,0,0,0,78.9,403.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.68,414a4.26,4.26,0,0,0,3.84.07l.2-.14a2,2,0,0,0-.32-.23l-14.65-8.45a4.28,4.28,0,0,0-3.85-.07l-.2.14a2.13,2.13,0,0,0,.33.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,373.22c-1,.59-1,1.59.13,2.22l14.65,8.45a4.26,4.26,0,0,0,3.84.07c1-.59,1-1.59-.12-2.22l-14.65-8.45A4.28,4.28,0,0,0,131,373.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.78,383.89a4.26,4.26,0,0,0,3.84.07l.2-.14a2,2,0,0,0-.32-.23l-14.65-8.45a4.28,4.28,0,0,0-3.85-.07l-.2.14a2.13,2.13,0,0,0,.33.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.57,377.51c-1,.6-1,1.59.12,2.22l14.65,8.45a4.23,4.23,0,0,0,3.84.07c1-.59,1-1.58-.12-2.22l-14.65-8.45A4.26,4.26,0,0,0,123.57,377.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.34,388.18a4.25,4.25,0,0,0,3.85.07l.2-.14a2.75,2.75,0,0,0-.33-.23l-14.65-8.45a4.26,4.26,0,0,0-3.84-.07l-.2.15a2,2,0,0,0,.32.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.38,391.76v8.32l3.72,2.15,3.72-2.15v-6.31a4.39,4.39,0,0,1,2-3.43L118,385l1.74-1c1.09-.63,2-.12,2,1.15v6.3l3.72-2.15V381a4,4,0,0,0,0-.5,3.69,3.69,0,0,0-.05-.37c0-.15-.07-.3-.11-.43s-.09-.22-.13-.32a2.16,2.16,0,0,0-.18-.3,1.28,1.28,0,0,0-.2-.26,1,1,0,0,0-.23-.22h0a1.38,1.38,0,0,0-.25-.17l-.12-.06-3.58-2.07a2.77,2.77,0,0,0-2.8.27l-14.39,8.31A8.77,8.77,0,0,0,99.38,391.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,385h0v4.29l3.72,2.15v-6.3c0-1.27-.89-1.78-2-1.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.1,393.91v8.32l3.72-2.15v-6.31a4.39,4.39,0,0,1,2-3.43L118,385h0l1.74-1c1.09-.63,2-.12,2,1.15v6.3l3.72-2.14V381a4,4,0,0,0,0-.5,3.69,3.69,0,0,0-.05-.37c0-.15-.07-.3-.11-.43s-.09-.22-.13-.32a2.16,2.16,0,0,0-.18-.3,1.28,1.28,0,0,0-.2-.26,1,1,0,0,0-.23-.22h0a1.38,1.38,0,0,0-.25-.17l-.12-.06a2.86,2.86,0,0,0-2.66.35L107.07,387A8.78,8.78,0,0,0,103.1,393.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.71 430.16 120.33 429.37 116.61 431.51 117.98 432.31 121.71 430.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.98 432.31 116.61 450.3 116.61 431.51 117.98 432.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.71 430.16 120.33 448.15 120.78 447.93 121.71 430.16",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.55 433.66 91.93 432.87 95.65 435.02 94.28 435.81 90.55 433.66",
    style: {
      fill: "#455a64"
    }
  }), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.55 433.66 91.93 451.65 91.47 451.44 90.55 433.66"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.67 425.07 77.04 424.27 80.76 426.42 79.39 427.22 75.67 425.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.65 453.8 94.28 435.81 95.65 435.02 95.65 453.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.76 426.42 80.76 445.2 79.39 427.22 80.76 426.42",
    style: {
      fill: "#37474f"
    }
  }), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.67 425.07 77.04 443.06 76.59 442.84 75.67 425.07"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "147.76 415.12 146.38 414.32 142.66 416.47 144.04 417.27 147.76 415.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.04 417.27 142.66 435.25 142.66 416.47 144.04 417.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.76 415.12 146.38 433.11 146.84 432.89 147.76 415.12",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.6 427.1 114.61 422.81 122.06 418.51 123.3 419.23 123.29 423.52 115.84 427.82 114.6 427.1",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.3 419.23 123.29 423.52 115.84 427.82 115.86 423.52 123.3 419.23",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.86 423.52 114.61 422.81 114.6 427.1 115.84 427.82 115.86 423.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.86 411.96 140.87 407.66 148.32 403.37 149.56 404.08 149.55 408.38 142.1 412.68 140.86 411.96",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.56 404.08 149.55 408.38 142.1 412.68 142.12 408.38 149.56 404.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.12 408.38 140.87 407.66 140.86 411.96 142.1 412.68 142.12 408.38",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257,362.9l-1.74-16,18.56,1.21s-.29,8.7-.55,13.62c-.15,2.92,3.82,8.32,3.82,8.32s-8.72,4.62-13.39,3-7.14-7.36-7.07-8.61S257,362.9,257,362.9Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.73,387.94c.29,0,.78,3-.79,4.27-1.81,1.49-7.16,4-14.29,3.26s-11-2.71-13.91-4.87-6.93-5.2-10.16-5.8c-3-.56-6.27-1.76-7.24-2.6s-.9-4.64-.9-4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,362.87a1.15,1.15,0,0,0-1.07.91c-.2,1.05-.39,4.1-.83,5.83a28.73,28.73,0,0,0-.55,9.25c.43,1.95,5.33,3.22,8.46,4.26a40.53,40.53,0,0,1,10.2,5.73c3.38,2.5,10.46,5,15.1,4.92,5.49-.13,11.65-1.87,13-4.25,1.7-2.95,2.92-6.35-5.27-9.71-1.56-.63-7-3.5-8.88-4.55-5-2.82-8.59-5.43-11-10.53a2.14,2.14,0,0,0-2.78-1.66c-1.35.2-6.75,1-8,1.55-1.08.5-2.62,1.08-2.58,2.38a4.35,4.35,0,0,0,.33,1.31c.1.26.19.61-.06.77s-.55,0-.77-.18a20.26,20.26,0,0,1-2.23-2.4,7.88,7.88,0,0,0-1.31-1.2,11.47,11.47,0,0,1-1.41-.81C257,364.05,257.07,363.48,257,362.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.25,388.85c-1.44-1.06-3-2.08-4.5-3h0s9.67,5.23,13.49,2.72c2.47-1.62,1.25-3.51,1.18-4.12s8.66-5.08,11.08-5.38h0c.68.33,1.25.6,1.61.74,8.19,3.36,7,6.76,5.27,9.71-1.38,2.38-5.83,4.29-12.93,4.41C283.81,394,276.63,391.35,273.25,388.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.73,382.68c5.09,1.78,2.94,2.69,1.53,2.91s-10-4.25-15.27-8c-5.49-3.87-9-8.15-11-9.58-.76-.53-1.58-1.18-2.31-1.79.12-1,.21-2,.3-2.47a1.15,1.15,0,0,1,1.07-.91c0,.61-.08,1.18.42,1.62a11.47,11.47,0,0,0,1.41.81,7.88,7.88,0,0,1,1.31,1.2,21.06,21.06,0,0,0,2.23,2.4C266.92,374,277.63,380.89,282.73,382.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,384.9a.53.53,0,0,1-.32-.1.44.44,0,0,1-.08-.65c1.4-1.64,8.11-5.59,11.84-5.28a.46.46,0,0,1,.45.5.47.47,0,0,1-.54.42c-3.49-.28-9.86,3.63-11,4.94A.5.5,0,0,1,283.89,384.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.43,382.46a.49.49,0,0,1-.32-.1.44.44,0,0,1-.08-.65c1.4-1.64,8.11-5.59,11.84-5.28a.48.48,0,0,1,.46.51.5.5,0,0,1-.55.42c-3.48-.29-9.85,3.63-11,4.93A.52.52,0,0,1,279.43,382.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,380.16a.51.51,0,0,1-.32-.1.43.43,0,0,1-.08-.65c1.4-1.65,8.11-5.6,11.84-5.28a.47.47,0,0,1,.45.5.5.5,0,0,1-.55.42c-3.48-.29-9.85,3.63-11,4.93A.57.57,0,0,1,275,380.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.84,377.51a.53.53,0,0,1-.32-.1.44.44,0,0,1-.08-.65c1.4-1.65,8.12-5.6,11.84-5.28a.46.46,0,0,1,.45.5.49.49,0,0,1-.54.42c-3.48-.29-9.86,3.63-11,4.93A.55.55,0,0,1,270.84,377.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.78,374.85a.46.46,0,0,1-.4-.74c1.93-2.33,9-5.66,12.69-5.34a.48.48,0,0,1,.46.5.5.5,0,0,1-.55.42c-3.36-.28-10.1,2.92-11.81,5A.48.48,0,0,1,266.78,374.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.35,371.64l4.23-15.18-18.89-2.9-.84,14.7s-2,5.25-.86,7.18,13.71,4.12,14.88,2.86S220.35,371.64,220.35,371.64Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.41,404.76c-.62,4.7-1.66,7.73-3.76,10.26s-5.77,2.91-9.39,1.6-8.17-4.12-9-8.36-.4-7,.71-11.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.85,368.26c-1.52-.1-1.22,6.36-2.5,12.63-1.37,6.71-3.87,9.23-5.07,14.72-1.36,6.28-1.15,9.2,1.16,13.42s11.13,9.24,15.95,4.3c3.92-4,4.39-9,4.47-15.48a140.34,140.34,0,0,1,.7-16.33c.59-4.76,2.06-9,.78-9.69-.15.69-.3,1.57-.45,2.25-.12.52-.44,3.1-1.28,3a9.12,9.12,0,0,1,.09-1.81,2.05,2.05,0,0,0-.31-1.61,7.11,7.11,0,0,0-2.43-1.26c-1.47-.46-4.1-1-5.6-1.36-.75-.16-1.5-.3-2.26-.39a6.58,6.58,0,0,0-1.93,0,1.21,1.21,0,0,0-.86.54,1.92,1.92,0,0,0-.13.72,4.37,4.37,0,0,1-.27,1.29c-.07.18-.23.39-.44.32a.39.39,0,0,1-.22-.42c0-.78.19-1.32.29-2.22,0-.41.15-1,.19-1.38S204.79,368.67,204.85,368.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.74,393.84c-.2.9-1.48,6.9.35,8.26s3.41-3.19,3.41-3.19,4.91-.64,11.75,3c-.42.95.45,4.37,2.42,3.93s3.16-7.34,3.18-7.43c-.1,6.17-.65,11-4.46,14.92-4.82,4.94-13.64-.08-15.95-4.3s-2.52-7.14-1.16-13.42C197.42,395,197.58,394.4,197.74,393.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,399.4c-.17,2.31-2.73,1.18-2.64-2.11s2.63-10.77,3-16.4c.55-7.73,1-12.73,2.5-12.63l0,.24-.4,3.21a12.1,12.1,0,0,0-.17,1.38c-.34,4.72-.53,13.89-1.27,18.15A66.31,66.31,0,0,0,202,399.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.44,401.74a64.61,64.61,0,0,0,2-7.94c.79-4.21,3.46-12.63,4.79-17.15a10.45,10.45,0,0,0,.7-2.57c.14-.63.28-1.44.42-2.1,0-.05,0-.1,0-.14.92.52.55,4.18,0,6.07s-1.15,3.91-1.8,6.62c-1.65,5.34-1.91,13.38-3,16.45S211.8,404,212.44,401.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.39,402.12a.7.7,0,0,1-.2-.08,20.92,20.92,0,0,0-11.58-2.63A.62.62,0,0,1,201,399a.45.45,0,0,1,.44-.55,21.8,21.8,0,0,1,12.37,2.82.48.48,0,0,1,.2.69A.55.55,0,0,1,213.39,402.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,397.26a.67.67,0,0,1-.18-.07,26,26,0,0,0-13-2.94.61.61,0,0,1-.65-.46.46.46,0,0,1,.46-.53,26.77,26.77,0,0,1,13.69,3.11.49.49,0,0,1,.22.69A.54.54,0,0,1,215,397.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.5,389.52a.59.59,0,0,1-.46-.39.46.46,0,0,1,.39-.58c6.91-1.1,13.41,2.83,13.68,3a.48.48,0,0,1,.2.69.6.6,0,0,1-.77.11c-.06,0-6.38-3.85-12.8-2.82A.49.49,0,0,1,202.5,389.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,385.07a.62.62,0,0,1-.45-.38.45.45,0,0,1,.38-.59,20.32,20.32,0,0,1,14,3,.48.48,0,0,1,.14.7.59.59,0,0,1-.78.06,19.33,19.33,0,0,0-13-2.78A.53.53,0,0,1,203.17,385.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,380.08a.61.61,0,0,1-.44-.38.44.44,0,0,1,.36-.59c7.13-1.35,13.77,3,14,3.14a.49.49,0,0,1,.17.7.58.58,0,0,1-.78.08c-.07,0-6.48-4.2-13.1-2.95A.57.57,0,0,1,204,380.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,211.27c-3.55,37.24-5.19,88.28-5.19,88.28-.31,2.83-2.37,7.64-4,21.59-1.68,14.71-1.73,35.52-1.73,35.52s9.91,5.68,18.18,3c0,0,8.24-32.59,12.76-49.88,4.29-16.37,10.32-41.31,10.32-41.31l3.37,26.3s.35,9.13.53,16.57c.21,8.65,5.11,41.84,5.11,41.84s9.76,6.49,18.42,0c0,0,2.57-48.51,3-58.91.83-20.4.68-60,.41-86.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.78,268.52l4.71-26.46s10-1.29,15.19-5.86c0,0-3.41,6.1-12.86,8.35l-4.63,24.08,1,26.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.29,357.07c2,2.81,11.13,5.74,18.54,3.34l1.38-5.72c-5.59,1.69-15.23-.16-19.71-3.86Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.73,354.11c2.46,2.41,11.71,3.74,18.6.07l.39-5.87c-5.23,2.64-14.76,2.63-19.8-.23Z",
    style: {
      fill: "#242424"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.58,170.49c-2.41,2-4.89,5-9,8.52s-10.3,9.61-16.28,13.32-8.95,5.22-16.65-2.44c-9.77-9.73-19.45-23.45-19.45-23.45l-.45-28.89c6.39,1.8,10.11,5.12,14.16,11,7.63,11.18,12.79,18.38,17.22,24.83,0,0,17.6-10.84,19.88-12.55a9.5,9.5,0,0,0,3.54-5.16,44,44,0,0,1,1.7-5.09c.68-1.77.94-2.44,1.73-4.66s1.32-5.94,1.57-6.76c.49-.94,1.87-.89,3.1,1.34a9,9,0,0,1,.63,4.44c0,1.35-.41,3,0,3.21s2.31-.82,4.22-1.33,3.6-1.38,5.76-.79a2.53,2.53,0,0,1,1.83,3.3A3.28,3.28,0,0,1,340,150.7a2.73,2.73,0,0,1,2.08.58,2.94,2.94,0,0,1,.14,3.74,1.68,1.68,0,0,1,1.68,1.43c.26,1.26.16,2.52-1.1,3.05,0,0,1.05.22,1.14.83a3,3,0,0,1-.91,2.81,9.93,9.93,0,0,1-3.6,1s-.18.46-1.37,1.11a29,29,0,0,1-4,2.28C332.53,168.15,329.49,168.92,327.58,170.49Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.15,173.43a14.1,14.1,0,0,0-5.88,9.43,10.76,10.76,0,0,1,5-10.66Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.76,137.42a20.15,20.15,0,0,1,9.56,5.3c2.72,2.62,7.67,10.17,10.61,14.34s6.09,8.59,6.09,8.59.36,10.95-13.36,17.09l-12.91-16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.49,161.26a5.9,5.9,0,0,0,1.6-.55,15.19,15.19,0,0,1,1.54-.44c1.06-.26,2.12-.49,3.18-.77-1.09.09-2.17.23-3.25.42a9.5,9.5,0,0,0-1.62.38,5.82,5.82,0,0,1-1.48.49,3.28,3.28,0,0,1-1.48-.34,3.65,3.65,0,0,1-1.31-.76,2.16,2.16,0,0,1-.31-.67.74.74,0,0,1,.13-.67,1.65,1.65,0,0,1,.92-.63,5.43,5.43,0,0,0,1.14.19,5.16,5.16,0,0,0,1.81-.49c.56-.25,1.11-.49,1.65-.76,1.08-.53,2.16-1.06,3.22-1.64-1.14.4-2.26.85-3.37,1.3a11.73,11.73,0,0,1-3.32,1.12,4.53,4.53,0,0,1-1.67-.34,9.23,9.23,0,0,1-1.55-.82,1.46,1.46,0,0,1-.76-1.37,1.4,1.4,0,0,1,.43-.83l.41-.08c.67-.13,1.37-.17,2.07-.29a7.29,7.29,0,0,0,2-.67,17,17,0,0,0,3.5-2.34,12.89,12.89,0,0,1-1.79,1.08,20.2,20.2,0,0,1-1.85.95,8.1,8.1,0,0,1-2,.56c-.68.11-1.38.14-2.09.26-.35.06-.7.15-1,.19s-.45,0-.62-.32a1.78,1.78,0,0,1,.37-1.73,6.48,6.48,0,0,1,3.33-2.25l.05,0,0,0a2.54,2.54,0,0,1,.43-.83,6,6,0,0,1,.62-.73,5.59,5.59,0,0,0-.71.67,2.74,2.74,0,0,0-.5.78,6.25,6.25,0,0,0-3.58,2.19,3.08,3.08,0,0,0-.5,1,1.59,1.59,0,0,0,.07,1.19,1.3,1.3,0,0,0,.43.49l.09,0a7.71,7.71,0,0,1-3.4,9.63,8.93,8.93,0,0,0,3.53-2.46,7.39,7.39,0,0,0,1.72-3.08l.41.56a.89.89,0,0,0,0,.28,2.56,2.56,0,0,0,.31.82,3.49,3.49,0,0,0,1.44.95,6.44,6.44,0,0,0,1,.35,1.08,1.08,0,0,0-.14.44,1.56,1.56,0,0,0,.22.7,5.34,5.34,0,0,0,.92,1,5.81,5.81,0,0,0,.57.4,1.88,1.88,0,0,0,.67.25,5.2,5.2,0,0,0,1.36.07l-1.26-.42a2,2,0,0,1-.54-.27,6.12,6.12,0,0,1-.5-.39,9.74,9.74,0,0,1-.93-.88,1.07,1.07,0,0,1-.28-.91A2.59,2.59,0,0,0,336.49,161.26Zm-4.71-7.13h0l0,0Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-2",
    d: "M234.34,135c-3.71.77-8.43,1.73-13.16,3s-7.89,2.15-12.17,4.53c0,0,.07,18,3.6,34.42.82,3.77,3.55,14.18,4,22.16A127.06,127.06,0,0,1,216,224s12.3,9.12,38.57,7.14c20.62-1.55,23.3-9.15,23.3-9.15s-.37-34.38-.91-49.59c-.7-20-6.75-31.51-11.21-35l-13.53-2.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,219.38c7.55,4.65,20,7.54,30.56,8s20.17-1.43,24.84-3.91,6.46-5,6.46-5l.36,8.73s-6.05,8-26.44,8.66c-19.08.62-36.5-8.69-36.5-8.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.61,225.75c-3.31,1.56-6.29,3.67-7,5.66-1,2.91-2.61,17.22-1.08,19.71s14.46,9.16,17.82,9.46,7.72-3.66,8.6-4.86,2.06-19.48,1.87-20.9S219.61,225.75,219.61,225.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.17,233.51a18.57,18.57,0,0,0,.05,5.32,7.57,7.57,0,0,0,2.55,4.37,16.93,16.93,0,0,0,4.48,2.65,21.47,21.47,0,0,0,5,1.54,6.66,6.66,0,0,0,4.78-.82,7.5,7.5,0,0,0,2.74-4.11,25.88,25.88,0,0,0,.62-2.59,5.19,5.19,0,0,1,1.51-2.4,11,11,0,0,1,4.87-2.38,11.74,11.74,0,0,0-4.47,2.78,4.46,4.46,0,0,0-1.2,2.17c-.13.82-.25,1.79-.48,2.67a8.09,8.09,0,0,1-3,4.76,7.71,7.71,0,0,1-5.57,1,20.8,20.8,0,0,1-5.25-1.69,16.08,16.08,0,0,1-4.63-3,8.15,8.15,0,0,1-2.5-4.91A16.86,16.86,0,0,1,212.17,233.51Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M223,108.34c0,.72,2.72,1.89,2.72,1.89L224.5,106Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223,108.34c0,.72,2.72,1.89,2.72,1.89L224.5,106Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229,92.28s-3.18.24-5.26,4.25c-1.05,2-1.8,5.69,1.07,16.2a42.08,42.08,0,0,0,5.05,11.59,5.21,5.21,0,0,0,3,2.41l-.21-8.08-.3-5.63s4.54-4.11,4.93-8.16c.5-5.2-1.53-8.14-1.53-8.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.87,92.55c.79-4.54,6.54-10,17.65-10.55,9.1-.48,14.23,4.29,17.4,9.6a10.61,10.61,0,0,1,.53,10.1l-27.85-1.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.25,121c4.19,2,6.1-1.28,6.1-1.28l0,17c8,10.75,30.13,6.48,21.34-1.57l0-3.79a25.13,25.13,0,0,0,3.63-.36c3.7-.58,6-2.31,7.1-6.33a50.58,50.58,0,0,0,1.26-8.41c.25-4.21.29-8.08-.76-11-.74-2.07.13-4.78-.44-7.33-.43-2-1.27-4.08-3.06-5-4.45-2.2-8.56,1-14.75,3.39-2.57,1-8.79,1.44-10.43.67,2.16,2.38,2.14,9.92-1,13a6.77,6.77,0,0,1-1.6,2.07c-1.35,1.18-2.46-1.86-3.6-3.05a4.67,4.67,0,0,0-7.26,1.67A7.61,7.61,0,0,0,225.25,121Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.63,131.41c-4.86,0-9.17-.63-12-1.84s-5.41-5.09-6.24-8.94c0,3.1,1.36,8.59,5.7,10.87s9.41,2.41,12.6,2.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,106.94c-1.13,2.26.16,9.39,2.29,10.28s4.55-.53,9.21-1.87c3-.86,6-1.55,10-.47,2.18.6,6.34,2.55,7.13,1.43-.27,5.3-.26,12.93-6.13,14.82-4.17,1.35-13.06,1.58-18.28-1.14s-6.19-5.85-7.15-10.1a79.57,79.57,0,0,0-2.68-8.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.18,120l-.15-.58a4.66,4.66,0,0,0-1-1.9,4,4,0,0,0-2-1.06c-2.12-.47-4.35-.38-6,1.19a5.35,5.35,0,0,0-1.63,4.07c0,.94.73,1.27,1.59,1.52a2.78,2.78,0,0,0,2.86-.55,1.46,1.46,0,0,1,1.89-.2,10.4,10.4,0,0,0,.93.71,2.5,2.5,0,0,0,1.41.06,3.27,3.27,0,0,0,1.23-.34,2.17,2.17,0,0,0,1-1.59A4,4,0,0,0,257.18,120Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.18,101.55l-4.1,1.73a2.33,2.33,0,0,1,1.23-3A2.17,2.17,0,0,1,245.18,101.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.81,102.3l-4.18-1.65a2.16,2.16,0,0,1,2.85-1.31A2.36,2.36,0,0,1,261.81,102.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.37,106.49a1.82,1.82,0,1,0,1.75-1.88A1.81,1.81,0,0,0,243.37,106.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.57,106.1a1.82,1.82,0,1,0,1.75-1.88A1.82,1.82,0,0,0,257.57,106.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.47,102.56l1.5,11.56,6.11-2.26A27.18,27.18,0,0,0,250.47,102.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.45,117.74l4.73,1.56a2.45,2.45,0,0,1-3.1,1.67A2.6,2.6,0,0,1,249.45,117.74Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,118.59a3.05,3.05,0,0,0-.6-.06,2.58,2.58,0,0,0,1.72,2.44,2.43,2.43,0,0,0,.79.11A2.27,2.27,0,0,0,250,118.59Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.39,102.37a21.15,21.15,0,0,0,1.61,6c.45-.58,1-1.15,1.48-1.7A37.17,37.17,0,0,1,235,99.19h0c9.09-4.43,20.3-6.12,29.35-3.89a20.21,20.21,0,0,0-1.77-5,21.88,21.88,0,0,0-41.23,12.07Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.38,80.9c1.08-.55,6.54-2.29,7-2.43,2.83-.91,7.4-1,12.18,2.7a21.5,21.5,0,0,1,7.58,11.46l-5.8,1.93-1.86.22c-.77-4.18-6.61-13.11-14.57-13.25a6,6,0,0,0-1.12,0,10.28,10.28,0,0,0-3.06.69,29.61,29.61,0,0,0-3,2.49A4.8,4.8,0,0,1,230.38,80.9Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.38,80.9c1.08-.55,6.54-2.29,7-2.43,2.83-.91,7.4-1,12.18,2.7a21.5,21.5,0,0,1,7.58,11.46l-5.8,1.93-1.86.22c-.77-4.18-6.61-13.11-14.57-13.25a6,6,0,0,0-1.12,0,10.28,10.28,0,0,0-3.06.69,29.61,29.61,0,0,0-3,2.49A4.8,4.8,0,0,1,230.38,80.9Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.46,94.79c-.91-4.87-8.75-16.27-18.75-12.54a30.81,30.81,0,0,0-3.05,2.49,4.83,4.83,0,0,1,2.72-3.84c2.6-1.3,7.84-2,13.36,2.22a21.46,21.46,0,0,1,7.58,11.45Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.46,94.79c-.91-4.87-8.75-16.27-18.75-12.54a30.81,30.81,0,0,0-3.05,2.49,4.83,4.83,0,0,1,2.72-3.84c2.6-1.3,7.84-2,13.36,2.22a21.46,21.46,0,0,1,7.58,11.45Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.84,97.51c.42-.38,2.36-4.72,9.54-8.68C248.8,86.38,258,86,262.09,86c7.2-.06,9,1.4,9.06,2.44,0,.25.15,1.39.19,1.64a1,1,0,0,1-.14.68c-1,1.62-6.81,4.53-6.81,4.53-9-2.23-20.26-.54-29.35,3.89Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.84,97.51c.42-.38,2.36-4.72,9.54-8.68C248.8,86.38,258,86,262.09,86c7.2-.06,9,1.4,9.06,2.44,0,.25.15,1.39.19,1.64a1,1,0,0,1-.14.68c-1,1.62-6.81,4.53-6.81,4.53-9-2.23-20.26-.54-29.35,3.89Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,99.19c9.09-4.43,20.3-6.12,29.35-3.89,0,0,5.77-2.91,6.81-4.53.56-.9,0-3.15-8.91-3.08-4.12,0-13.29.37-17.72,2.81C237.4,94.47,235.45,98.81,235,99.19Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,99.19c9.09-4.43,20.3-6.12,29.35-3.89,0,0,5.77-2.91,6.81-4.53.56-.9,0-3.15-8.91-3.08-4.12,0-13.29.37-17.72,2.81C237.4,94.47,235.45,98.81,235,99.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25,135.61h.06S231.27,135.55,231.25,135.61Zm3.6,12.79c-3.53-10.9-3.69-12.57-3.6-12.79-.69.12-9,1.65-13.65,3.08a53,53,0,0,0-9.1,3.85s.41,22.56,2.86,33S216,195.65,216,204.07s-1.63,23.09-1.63,23.09,2.45,1.76,10.19,5.42a35.92,35.92,0,0,0,14.66,3.48s1.23-27.78,1.23-43S239.33,162.25,234.85,148.4Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.86,200.7c.07,1.14.11,2.27.11,3.37v.53a54.58,54.58,0,0,0,24.17,5c0-1.15.06-2.3.09-3.43A50.69,50.69,0,0,1,215.86,200.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.88,217.93a50.34,50.34,0,0,1-24.23-5.59c-.08,1.26-.17,2.52-.27,3.74a54,54,0,0,0,24.39,5.27C239.81,220.24,239.84,219.1,239.88,217.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.65,135.2s8.89,7.15,12.54,22.29c2.9,12,3,27,3.61,45.35s0,30.52,0,30.52,7.51-1.29,10.08-6.56c-.73-22.6-1.17-44.45-1.18-52.89a90.86,90.86,0,0,0-4.38-26.1,25.9,25.9,0,0,0-7.23-11.11Z",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.87,204.83c0,1.18.06,2.32.08,3.44A36.34,36.34,0,0,0,274.4,207a31.63,31.63,0,0,0,3.86-1.59c0-1.31-.06-2.59-.09-3.86a22.87,22.87,0,0,1-2.55,1.34A30.11,30.11,0,0,1,268.87,204.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.4,218.4a31,31,0,0,0,4.17-1.72c0-1.31-.07-2.61-.11-3.9a23.35,23.35,0,0,1-2.84,1.52,30,30,0,0,1-6.56,1.94c0,1.21,0,2.36,0,3.46A36,36,0,0,0,274.4,218.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.81 180.41 260.28 191.05 244.95 237.99 245.76 239.02 285.31 228.12 302.62 181.45 301.81 180.41",
    style: {
      fill: "#242424"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.09 192.09 245.76 239.02 244.95 237.99 260.28 191.05 261.09 192.09",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.62 181.45 261.09 192.09 245.76 239.02 285.31 228.12 302.62 181.45",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.62,190.19s.21-.71.48-1.58-2.15-.61-5.37.58l-7.47,1.55c-3.23,1.19-6.25,2-6.51,2.89l-.48,1.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M292.66,183.14c.16-.55-.76-.52-2.08-.29l-2.39.59s1.15-2.25-4.47-1.25c-6.18,1.1-6.58,4.1-6.58,4.1a25.84,25.84,0,0,1-3,.8c-2.07.48-2.32.85-2.54,1.4l-.38,1,21.16-5.41S292.49,183.68,292.66,183.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.23,186c-2,.69-2.81,1-3.21,2.38-.46,1.54-.59,2.18-.59,2.18l-11.06,3.27s.78-2.25,1-3-1.2-.89-3.13-.2l.61-1.87L291,184.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.17,190.27s.21-.71.48-1.58-2.15-.61-5.38.57l-7.46,1.56c-3.23,1.19-6.25,2-6.51,2.89l-.48,1.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.44,161.43c3.78-15.15,8-18.6,16.66-20.19,7.66,12.24,3.28,31.31,3.28,31.31l-5.2,23.22c1.41,1.24,22.66,14.88,26.43,16.2,1.36.47,3.95,0,5.33-.44,3.7-1.17,6.26-.74,9.81-.5l-1.64,5a23.87,23.87,0,0,0,4.58,1.15,27.33,27.33,0,0,0,7.45.09c2.24-.22,4.7-.64,6.59.59.45.3.88.8.71,1.31-.11.35-.47.56-.78.77a4.55,4.55,0,0,0-1.68,2.16,7.74,7.74,0,0,1-3,4.07,27,27,0,0,1-3.79,2.51,26.17,26.17,0,0,1-7.56,2.12,12.71,12.71,0,0,1-2.81.29c-3.69-.14-7.14-1.33-10.63-2.39-4.28-1.3-6.73-2.43-10.2-3.57-2.32-.76-6.78-2.4-9.06-3.26-13.31-5-31.4-11.51-32.34-17.89S193.54,177.07,197.44,161.43Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,140.22c-9.78,3-11.72,4.37-14.54,12.16-2.72,7.53-8.27,31-9.07,36.71,4.49,4.42,18.23,7.24,23.12,4L218.08,173C219.67,166.19,222.83,150.87,214,140.22Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.27,71.85A28.58,28.58,0,0,0,286.45,91v3.27a28.63,28.63,0,0,0,57.05,1.37l.15-3.28a28.63,28.63,0,0,0-48.39-20.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,70.1a31.11,31.11,0,0,0-4.3,39.88l-4.11,8.74a1.81,1.81,0,0,0,2.33,2.44l8.92-3.69a31.07,31.07,0,1,0-2.84-47.37Zm42.18,2.72a28.47,28.47,0,0,1,7.89,19.5l-.15,3.28a28.62,28.62,0,0,1-57.05-1.37V91a28.63,28.63,0,0,1,49.32-18.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.77,72.82a28.47,28.47,0,0,1,7.89,19.5l-.15,3.28a28.62,28.62,0,0,1-57.05-1.37V91a28.63,28.63,0,0,1,49.32-18.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Check--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.3,109.26a4.14,4.14,0,0,1-3-1.31l-9.37-10a4.14,4.14,0,0,1,6-5.65l6.08,6.5,14.4-18.24a4.13,4.13,0,0,1,6.49,5.12l-17.37,22a4.13,4.13,0,0,1-3.07,1.57Z",
    style: {
      fill: "#242424"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.7c349bb9b7708769e4787d47312e2a96.svg";
export { ForwardRef as ReactComponent };